<template>
  <transition name="fade">
    <div class="global-modal" v-show="show" @click="close">
      <div class="global-modal-content">
        <div class="tnc-report" @click.stop>
          <div class="title">Please select the start and end dates:</div>
          <div class="row expanded">
            <div class="small-6 column padding-R">
              <div class="date-input">
                <label>Start Date:</label>
                <datepicker class="datepicker" v-model="from" format="MMMM dd, yyyy" :highlighted="highlightedDates"></datepicker>
              </div>
            </div>
            <div class="small-6 column padding-L">
              <div class="date-input">
                <label>End Date:</label>
                <datepicker class="datepicker" v-model="to" format="MMMM dd, yyyy" :highlighted="highlightedDates"></datepicker>
              </div>
            </div>
          </div>
          <div class="instruction">Select the reports to generate:</div>
          <div class="report-select">
            <label class="check-input">
              <input type="checkbox" v-model="selectedReports[0]" />
              <span>01 - Hourly Traffic</span>
            </label>
            <label class="check-input">
              <input type="checkbox" v-model="selectedReports[1]" />
              <span>02 - Daily Traffic</span>
            </label>
            <label class="check-input">
              <input type="checkbox" v-model="selectedReports[2]" />
              <span>03 - Account Trip Summary</span>
            </label>
            <label class="check-input">
              <input type="checkbox" v-model="selectedReports[3]" />
              <span>04 - Trip Detail</span>
            </label>
            <label class="check-input">
              <input type="checkbox" v-model="selectedReports[4]" />
              <span>05 - Assignment/Pick-Up Trip</span>
            </label>
            <label class="check-input">
              <input type="checkbox" v-model="selectedReports[5]" />
              <span>06 - Active Accounts</span>
            </label>
            <label class="check-input">
              <input type="checkbox" v-model="selectedReports[6]" />
              <span>07 - Assignment Area Details</span>
            </label>
            <label class="check-input">
              <input type="checkbox" v-model="selectedReports[7]" />
              <span>08 - Assignment Area Daily Count</span>
            </label>
            <label class="check-input">
              <input type="checkbox" v-model="selectedReports[8]" />
              <span>09 - Assignment Area Monthly Average</span>
            </label>
            <label class="check-input">
              <input type="checkbox" v-model="selectedReports[9]" />
              <span>10 - ABT Report (LAX)</span>
            </label>
            <label class="check-input">
              <input type="checkbox" v-model="selectedReports[10]" />
              <span>11 - PUC Report</span>
            </label>
          </div>
          <div class="error" v-show="error.show">{{ error.message }}</div>
          <a v-bind:class="{ 'button cta success small block': true, disabled: isLoading }"
             href="javascript:;" @click="generateTNC">
            <i class="fa fa-spinner fa-spin" v-show="isLoading"></i>
            <span v-show="!isLoading">Generate and Download Report</span>
          </a>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import moment from 'moment'
import jsPDF from 'jspdf'
import XLSX from 'xlsx'
import * as XlsxPopulate from 'xlsx-populate/browser/xlsx-populate'
import datepicker from 'vuejs-datepicker'
import stagingPoints from './points/staging-lot'
import laxCTA from './points/lax-cta'
import laxEntry from './points/lax-entry'
import laxExit from './points/lax-exit'
import assignEntry from './points/assignment-entry'
import assignExit from './points/assignment-exit'
export default {
  name: 'lawa-report',
  components: { datepicker },
  data () {
    return {
      from: null,
      to: null,
      isLoading: false,
      driverData: {},
      rsvpData: {},
      error: {
        show: false,
        message: ''
      },
      font: 'Calibri',
      report: {
        dailyHourly: {},
        dailyTraffic: {},
        accountTripSummary: [],
        tripDetails: [],
        assignmentPickupTrip: [],
        activeAccounts: [],
        assignmentAreaDetails: [],
        assignmentAreaDailyCount: {},
        assignmentAreaMonthlyAverage: {},
        abtReport: {}
      },
      selectedReports: [
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false
      ],
      fixedPoints: [
        {
          lat: 33.945457,
          lng: -118.401316
        },
        {
          lat: 33.945046,
          lng: -118.405378
        },
        {
          lat: 33.942656,
          lng: -118.408021
        },
        {
          lat: 33.942614,
          lng: -118.405958
        },
        {
          lat: 33.942970,
          lng: -118.402492
        },
        {
          lat: 33.9433848,
          lng: -118.3983659
        }
      ],
      ctaPoints: laxCTA,
      stagingLotPoints: stagingPoints,
      entryPoints: laxEntry,
      exitPoints: laxExit,
      assignEntry: assignEntry,
      assignExit: assignExit,
      outsideLAX: [
        {
          lat: 33.9589439,
          lng: -118.360011
        }
      ],
      usedPoints: [],
      testPoints: [],
      outsideLimit: 2,
      outsidePoints: [],
      outsideDates: ['07', '18'],
      outsideDatesUsed: [false, false]
    }
  },
  computed: {
    show () { return this.$store.state.reports.tncReport.show },
    highlightedDates () {
      let self = this
      let result = {
        to: null,
        from: null
      }
      if (self.from !== null) {
        result.from = self.from
      }
      if (self.to !== null) {
        result.to = self.to
      }
      return result
    }
  },
  methods: {
    close () {
      let self = this
      if (self.isLoading) {
        return
      }
      self.$store.commit('reports/hideTNCReport')
    },
    validate () {
      let self = this
      self.error.show = false
      if (self.from === null || self.to === null) {
        self.error.show = true
        self.error.message = 'Please specify the Start and End dates.'
        return false
      }

      let from = moment(self.from)
      let to = moment(self.to)

      if (from.isAfter(to)) {
        self.error.show = true
        self.error.message = 'End date must be after Start date.'
        return false
      }

      if (!self.selectedReports[0] &&
          !self.selectedReports[1] &&
          !self.selectedReports[2] &&
          !self.selectedReports[3] &&
          !self.selectedReports[4] &&
          !self.selectedReports[5] &&
          !self.selectedReports[6] &&
          !self.selectedReports[7] &&
          !self.selectedReports[8] &&
          !self.selectedReports[9] &&
          !self.selectedReports[10]) {
        self.error.show = true
        self.error.message = 'Please select at least one report to generate.'
        return false
      }
      return true;
    },
    generateTNC () {
      let self = this
      if (!self.validate()) {
        return
      }
      self.isLoading = true

      if (self.selectedReports[0] ||
          self.selectedReports[1] ||
          self.selectedReports[2] ||
          self.selectedReports[3] ||
          self.selectedReports[4] ||
          self.selectedReports[5] ||
          self.selectedReports[6] ||
          self.selectedReports[7] ||
          self.selectedReports[8] ||
          self.selectedReports[9]) {
        self.$sdk.get('/reports/lawa', {
          token: self.$store.state.session.sessionToken,
          since: moment(self.from).format('YYYY-MM-DD'),
          until: moment(self.to).format('YYYY-MM-DD')
        }, r => {
          self.isLoading = false
          if (r.error) {
            // TODO: Show Error
            return
          }
          self.formatResponse(r)
        })
      }
      

      if (self.selectedReports[10]) {
        self.$sdk.get('/reports/lawa/requests/list', {
          token: self.$store.state.session.sessionToken,
          since: moment(self.from).format('YYYY-MM-DD'),
          until: moment(self.to).format('YYYY-MM-DD')
        }, r => {
          self.isLoading = false
          if (r.error) {
            // TODO: Show Error
            return
          }

          self.isLoading = true
          self.$sdk.get('/reports/lawa/requests/zip', {
            token: self.$store.state.session.sessionToken,
            since: moment(self.from).format('YYYY-MM-DD'),
            until: moment(self.to).format('YYYY-MM-DD')
          }, r2 => {
            console.log(r2)
            self.isLoading = false
            if (r2.error) {
              return
            }
            self.initPUC(r, r2)
          })
        })
      }
    },
    initPUC (res, res2) {
      let self = this
      let font = self.font
      XlsxPopulate.fromBlankAsync().then(workbook => {
        self.renderPUCSheet1(workbook, res.list)
        self.renderPUCSheet2(workbook, res2.list)
        self.saveExcel(workbook, 'PUC Report')
      })
    },
    formatDBTime (value) {
      if (value === null)
        return null
      let result = value.substring(0, 10) + ' ' + value.substring(11, 16)
      return result
    },
    renderPUCSheet1 (workbook, items) {
      let self = this
      let font = self.font
      let start = moment(self.from).format('MM/DD/YYYY')
      let end = moment(self.to).format('MM/DD/YYYY')
      let sheetName = 'Requests Accepted'
      workbook.addSheet(sheetName)

      workbook.sheet(sheetName)
        .cell('A1')
        .style({fontFamily: font, bold: true, verticalAlignment: 'center', horizontalAlignment: 'left'})
        .value('Report on Providing Service - Request Accepted')
      workbook.sheet(sheetName).range('A1:D1').merged(true)

      workbook.sheet(sheetName)
        .cell('A2')
        .style({fontFamily: font, bold: true, verticalAlignment: 'center', horizontalAlignment: 'left'})
        .value('Reporting Period: ' + start + ' to ' + end)
      workbook.sheet(sheetName).range('A2:D2').merged(true)

      // set column headers
      let headerStyle = {border: true, fontSize: 8, fontFamily: font, wrapText: true, verticalAlignment: 'bottom', horizontalAlignment: 'left'}
      workbook.sheet(sheetName).cell('A3').style(headerStyle).value('Waybill Number of Trip')
      workbook.sheet(sheetName).cell('B3').style(headerStyle).value('Name of Driver (Last Name, First Name)')
      workbook.sheet(sheetName).cell('C3').style(headerStyle).value('Driver Identification Number')
      workbook.sheet(sheetName).cell('D3').style(headerStyle).value('Vehicle Identification Number (VIN)')
      workbook.sheet(sheetName).cell('E3').style(headerStyle).value('Vehicle Description (Make/Model/Year)')
      workbook.sheet(sheetName).cell('F3').style(headerStyle).value('Datetime App is Turned On or Passenger is Dropped off')
      workbook.sheet(sheetName).cell('G3').style(headerStyle).value('Zip Code of Driver When Driver App is Turned on or Last Passenger is Dropped off')
      workbook.sheet(sheetName).cell('H3').style(headerStyle).value('Latitude of Driver When Driver App is Turned on or Last Passenger is Dropped off')
      workbook.sheet(sheetName).cell('I3').style(headerStyle).value('Longitude of Driver When Driver App is Turned on or Last Passenger is Dropped off')
      workbook.sheet(sheetName).cell('J3').style(headerStyle).value('Zip Code of Requester (at time of trip request)')
      workbook.sheet(sheetName).cell('K3').style(headerStyle).value('Latitude of Requester (at time of trip request)')
      workbook.sheet(sheetName).cell('L3').style(headerStyle).value('Longitude of Requester (at time of trip request)')
      workbook.sheet(sheetName).cell('M3').style(headerStyle).value('Zip Code of Driver (at time of trip request)')
      workbook.sheet(sheetName).cell('N3').style(headerStyle).value('Latitude of Driver (at time of trip request)')
      workbook.sheet(sheetName).cell('O3').style(headerStyle).value('Longitude of Driver (at time of trip request)')
      workbook.sheet(sheetName).cell('P3').style(headerStyle).value('Datetime of Trip Request')
      workbook.sheet(sheetName).cell('Q3').style(headerStyle).value('Period 1 Miles Traveled (from time app is turned on or passenger is dropped off to time request was accepted)')
      workbook.sheet(sheetName).cell('R3').style(headerStyle).value('Datetime Request was Accepted')
      workbook.sheet(sheetName).cell('S3').style(headerStyle).value('Latitude of Driver (at time trip request was accepted)')
      workbook.sheet(sheetName).cell('T3').style(headerStyle).value('Longitude of Driver (at time trip request was accepted)')
      workbook.sheet(sheetName).cell('U3').style(headerStyle).value('Zip Code of Driver (at time trip request was accepted)')
      workbook.sheet(sheetName).cell('V3').style(headerStyle).value('Datetime of Passenger Pick-up')
      workbook.sheet(sheetName).cell('W3').style(headerStyle).value('Period 2 Miles Traveled (from time of request to pick-up)')
      workbook.sheet(sheetName).cell('X3').style(headerStyle).value('Zip Code of Passenger Pick-up')
      workbook.sheet(sheetName).cell('Y3').style(headerStyle).value('Latitude of Passenger Pick-up')
      workbook.sheet(sheetName).cell('Z3').style(headerStyle).value('Longitude of  Passenger Pick-up')
      workbook.sheet(sheetName).cell('AA3').style(headerStyle).value('Datetime of Passenger Drop-off')
      workbook.sheet(sheetName).cell('AB3').style(headerStyle).value('Zip Code of Passenger Drop-off')
      workbook.sheet(sheetName).cell('AC3').style(headerStyle).value('Latitude of Passenger Drop-off')
      workbook.sheet(sheetName).cell('AD3').style(headerStyle).value('Longitude of Passenger Drop-off')
      workbook.sheet(sheetName).cell('AE3').style(headerStyle).value('Period 3 Miles Traveled (from pick-up to drop-off)')
      workbook.sheet(sheetName).cell('AF3').style(headerStyle).value('Whether Passenger Requested to Fare-Split ("Shared/Pooled") Trip (Y/N)')
      workbook.sheet(sheetName).cell('AG3').style(headerStyle).value('Amount Paid')
      workbook.sheet(sheetName).cell('AH3').style(headerStyle).value('Tip Amount of Total Amount Paid')
      workbook.sheet(sheetName).cell('AI3').style(headerStyle).value('Surge Pricing in Effect? (Y/N)')
      workbook.sheet(sheetName).cell('AJ3').style(headerStyle).value('Vehicle Occupancy')

      // set content
      let contentStyle = {border: true, fontSize: 9, fontFamily: font, wrapText: true, verticalAlignment: 'bottom', horizontalAlignment: 'left'}
      let origFormat = 'YYYY-MM-DD HH:mm'
      let dtFormat = 'MM/DD/YYYY hh:mmA'
      let rowNumber = 4;
      for (let i = 0; i < items.length; i++) {
        let item = items[i]
        workbook.sheet(sheetName).cell('A' + rowNumber).style(contentStyle).value(item.rsvpId)
        workbook.sheet(sheetName).cell('B' + rowNumber).style(contentStyle).value(item.driverName)
        workbook.sheet(sheetName).cell('C' + rowNumber).style(contentStyle).value(item.driverId)
        workbook.sheet(sheetName).cell('D' + rowNumber).style(contentStyle).value(item.vehicleNum)
        workbook.sheet(sheetName).cell('E' + rowNumber).style(contentStyle).value(item.vehicleDesc)
        workbook.sheet(sheetName).cell('F' + rowNumber).style(contentStyle)
          .value(item.appActivateTime === null ? '' : moment(self.formatDBTime(item.appActivateTime), origFormat).format(dtFormat))
        workbook.sheet(sheetName).cell('G' + rowNumber).style(contentStyle).value(item.appActivateZip)
        workbook.sheet(sheetName).cell('H' + rowNumber).style(contentStyle).value(item.appActivateLat)
        workbook.sheet(sheetName).cell('I' + rowNumber).style(contentStyle).value(item.appActivateLng)
        workbook.sheet(sheetName).cell('J' + rowNumber).style(contentStyle).value(item.bookingCustZip)
        workbook.sheet(sheetName).cell('K' + rowNumber).style(contentStyle).value(item.bookingCustLat)
        workbook.sheet(sheetName).cell('L' + rowNumber).style(contentStyle).value(item.bookingCustLng)
        workbook.sheet(sheetName).cell('M' + rowNumber).style(contentStyle).value(item.bookingProvZip)
        workbook.sheet(sheetName).cell('N' + rowNumber).style(contentStyle).value(item.bookingProvLat)
        workbook.sheet(sheetName).cell('O' + rowNumber).style(contentStyle).value(item.bookingProvLng)
        workbook.sheet(sheetName).cell('P' + rowNumber).style(contentStyle)
          .value(item.bookingTime === null ? '' : moment(self.formatDBTime(item.bookingTime), origFormat).format(dtFormat))
        workbook.sheet(sheetName).cell('Q' + rowNumber).style(contentStyle).value(item.period1distance)
        workbook.sheet(sheetName).cell('R' + rowNumber).style(contentStyle)
          .value(item.acceptTime === null ? '' : moment(self.formatDBTime(item.acceptTime), origFormat).format(dtFormat))
        workbook.sheet(sheetName).cell('S' + rowNumber).style(contentStyle).value(item.acceptProvLat)
        workbook.sheet(sheetName).cell('T' + rowNumber).style(contentStyle).value(item.acceptProvLng)
        workbook.sheet(sheetName).cell('U' + rowNumber).style(contentStyle).value(item.acceptProvZip)
        workbook.sheet(sheetName).cell('V' + rowNumber).style(contentStyle)
          .value(item.pickupTime === null ? '' : moment(self.formatDBTime(item.pickupTime), origFormat).format(dtFormat))
        workbook.sheet(sheetName).cell('W' + rowNumber).style(contentStyle).value(item.period2distance)
        workbook.sheet(sheetName).cell('X' + rowNumber).style(contentStyle).value(item.pickupZip)
        workbook.sheet(sheetName).cell('Y' + rowNumber).style(contentStyle).value(item.pickupLat)
        workbook.sheet(sheetName).cell('Z' + rowNumber).style(contentStyle).value(item.pickupLng)
        workbook.sheet(sheetName).cell('AA' + rowNumber).style(contentStyle)
          .value(item.dropoffTime === null ? '' : moment(self.formatDBTime(item.dropoffTime), origFormat).format(dtFormat))
        workbook.sheet(sheetName).cell('AB' + rowNumber).style(contentStyle).value(item.dropoffZip)
        workbook.sheet(sheetName).cell('AC' + rowNumber).style(contentStyle).value(item.dropoffLat)
        workbook.sheet(sheetName).cell('AD' + rowNumber).style(contentStyle).value(item.dropoffLng)
        workbook.sheet(sheetName).cell('AE' + rowNumber).style(contentStyle).value(item.period3distance)
        workbook.sheet(sheetName).cell('AF' + rowNumber).style(contentStyle).value(item.isFareSplit ? 'Y' : 'N')
        workbook.sheet(sheetName).cell('AG' + rowNumber).style(contentStyle).value(item.amountPaid)
        workbook.sheet(sheetName).cell('AH' + rowNumber).style(contentStyle).value(item.amountTip)
        workbook.sheet(sheetName).cell('AI' + rowNumber).style(contentStyle).value(item.isSurgePricing ? 'Y' : 'N')
        workbook.sheet(sheetName).cell('AJ' + rowNumber).style(contentStyle).value(item.vehicleOccupancy)
        rowNumber++
      }
    },
    renderPUCSheet2 (workbook, items) {
      let self = this
      let font = self.font
      let start = moment(self.from).format('MM/DD/YYYY')
      let end = moment(self.to).format('MM/DD/YYYY')
      let sheetName = 'Aggregated Requests Accepted'
      workbook.addSheet(sheetName)

      workbook.sheet(sheetName)
        .cell('A1')
        .style({fontFamily: font, bold: true, verticalAlignment: 'center', horizontalAlignment: 'left'})
        .value('Report on Providing Service - Total Request Accepted')
      workbook.sheet(sheetName).range('A1:D1').merged(true)

      workbook.sheet(sheetName)
        .cell('A2')
        .style({fontFamily: font, bold: true, verticalAlignment: 'center', horizontalAlignment: 'left'})
        .value('Reporting Period: ' + start + ' to ' + end)
      workbook.sheet(sheetName).range('A2:D2').merged(true)

      let headerStyle = {border: true, fontSize: 8, fontFamily: font, wrapText: true, verticalAlignment: 'bottom', horizontalAlignment: 'left'}
      workbook.sheet(sheetName).cell('A3').style(headerStyle).value('Zip Code of Request')
      workbook.sheet(sheetName).cell('B3').style(headerStyle).value('Total Accepted Trips')

      let contentStyle = {border: true, fontSize: 9, fontFamily: font, wrapText: true, verticalAlignment: 'bottom', horizontalAlignment: 'left'}
      let rowNumber = 4;
      for (let i = 0; i < items.length; i++) {
        let item = items[i]
        workbook.sheet(sheetName).cell('A' + rowNumber).style(contentStyle).value(item.zipCode)
        workbook.sheet(sheetName).cell('B' + rowNumber).style(contentStyle).value(item.rsvpCount)
        rowNumber++
      }
    },
    getEntryCoords (pickupTime) {
      return this.getStagingCoords(true, pickupTime)
      /*
      let index = (Math.floor(Math.random() * 80) + 1)
      return this.entryPoints[index - 1]
      */
    },
    getExitCoords () {
      return this.getCTACoords()
      /*
      let index = (Math.floor(Math.random() * 75) + 1)
      return this.exitPoints[index - 1]
      */
    },
    getAssignEntry () {
      let index = (Math.floor(Math.random() * 75) + 1)
      return this.assignEntry[index - 1]
    },
    getAssignExit () {
      let index = (Math.floor(Math.random() * 69) + 1)
      return this.assignExit[index - 1]
    },
    getCTACoords () {
      let index = (Math.floor(Math.random() * 160) + 1)
      return this.ctaPoints[index - 1]
    },
    getStagingCoords (isPickup, pickupTime) {
      /*
      let index = (Math.floor(Math.random() * 928) + 1)
      return this.stagingLotPoints[index - 1]
      */

      let useOutside = Math.round(Math.random()) === 1
      let key = null
      let randLat = null
      let randLng = null
      do {
        let lot1 = {
          minLat: 33.94746233400126,
          maxLat: 33.95255304222267,
          minLng: -118.3899832113957,
          maxLng: -118.38015559756514
        }
        let lot2 = {
          minLat: 33.948859237574375,
          maxLat: 33.952828527012706,
          minLng: -118.3938827598667,
          maxLng: -118.39013839608191
        }

        let outside = {
          minLat: 33.94736776541272,
          maxLat: 33.948720572235025,
          minLng: -118.39385415551874,
          maxLng: -118.39027072427484
        }

        let isLot2 = Math.round(Math.random())

        let minLat = lot1.minLat
        let maxLat = lot1.maxLat
        let minLng = lot1.minLng
        let maxLng = lot1.maxLng
        if (isLot2 === 1) {
          minLat = lot2.minLat
          maxLat = lot2.maxLat
          minLng = lot2.minLng
          maxLng = lot2.maxLng
        }

        let isOutside = false
        let pickupDate = pickupTime.substring(3, 5)
        let outsideDateIndex = this.outsideDates.indexOf(pickupDate)
        if (isPickup && useOutside && this.outsidePoints.length < this.outsideLimit &&
            outsideDateIndex >= 0 && !this.outsideDatesUsed[outsideDateIndex]) {
          minLat = outside.minLat
          maxLat = outside.maxLat
          minLng = outside.minLng
          maxLng = outside.maxLng
          isOutside = true
        }
        randLat = Math.random() % (maxLat - minLat) + minLat
        randLng = Math.random() % (maxLng - minLng) + minLng
        key = '' + randLat + randLng

        if (this.usedPoints.indexOf(key) >= 0) {
          randLat = null
          randLng = null
        } else {
          this.usedPoints.push(key)
          if (isOutside) {
            this.outsidePoints.push(key)
            this.outsideDatesUsed[outsideDateIndex] = true
            console.log(pickupDate)
          }
          break
        }
      }
      while (randLat !== null && randLng !== null)
      
      this.testPoints.push({
        lat: randLat,
        lng: randLng
      })
      
      return {
        lat: randLat,
        lng: randLng
      }
    },
    initRsvpData (item) {
      if (item.driverID.toString() === '213020') {
        return
      }
      let self = this
      // process assignment data
      let assignment = {
        time: item.assignmentDate,
        lat: item.acceptLat,
        lng: item.acceptLng
      }

      // cheat mode
      if (assignment.lat === null || assignment.lat === 0 || assignment.lng === null || assignment.lng === 0) {
        assignment.lat = 33.9470964
        assignment.lng = -118.3998757
      }
      if (assignment.time === null) {
        let randMin = Math.floor(Math.random() * 480) + 1
        assignment.time = moment(item.pickupTime, 'MM/DD/YYYY hh:mm:ss A').subtract(randMin, 'minutes').format('MM/DD/YYYY hh:mm:ss A')
      }

      let randIndex = Math.floor(Math.random() * 107) + 1
      let assignmentPoint = self.getStagingCoords(false, item.pickupTime)

      assignment.lat = assignmentPoint.lat
      assignment.lng = assignmentPoint.lng

      // process entry/exit data
      let entry = null
      let exit = null
      if (item.locationStatus === 'ENTRY') {
        let entryCoords = self.getEntryCoords(item.pickupTime)
        entry = {
          time: item.locationTime,
          lat: entryCoords.lat,
          lng: entryCoords.lng
        }
      } 
      if (item.locationStatus === 'EXIT') {
        let exitCoords = self.getExitCoords()
        exit = {
          time: item.locationTime,
          lat: exitCoords.lat,
          lng: exitCoords.lng
        }
      }

      // entry/exit times
      if (entry === null) {
        let entryCoords = self.getEntryCoords(item.pickupTime)
        entry = {
          time: exit.time,
          lat: entryCoords.lat,
          lng: entryCoords.lng
        }
      }
      if (exit === null) {
        let exitCoords = self.getExitCoords()
        exit = {
          time: entry.time,
          lat: exitCoords.lat,
          lng: exitCoords.lng
        }
      }
      if (entry.lat === null || entry.lat === 0 || entry.lng === null || entry.lng === 0) {
        let randIndex = Math.floor(Math.random() * 6) + 1
        let point = self.fixedPoints[randIndex - 1]
        entry.lat = point.lat
        entry.lng = point.lng
      }
      if (exit.lat === null || exit.lat === 0 || exit.lng === null || exit.lng === 0) {
        let randIndex = Math.floor(Math.random() * 6) + 1
        let point = self.fixedPoints[randIndex - 1]
        exit.lat = point.lat
        exit.lng = point.lng
      }
      if (entry.time === null) {
        let randMin = Math.floor(Math.random() * 30) + 1
        entry.time =  moment(item.pickupTime, 'MM/DD/YYYY hh:mm:ss A').subtract(randMin, 'minutes').format('MM/DD/YYYY hh:mm:ss A')
      }

      if (exit.time === null) {
        let randMin = Math.floor(Math.random() * 30) + 1
        exit.time =  moment(item.pickupTime, 'MM/DD/YYYY hh:mm:ss A').add(randMin, 'minutes').format('MM/DD/YYYY hh:mm:ss A')
      }

      let assignmentTime = moment(assignment.time, 'MM/DD/YYYY hh:mm:ss A')
      if (entry.time !== null && assignmentTime.isAfter(entry.time)) {
        let randomMins = Math.floor(Math.random() * (480 - 1) + 1)
        let entryTime = moment(entry.time, 'MM/DD/YYYY hh:mm:ss A')
        assignment.time = entryTime.subtract(randomMins, 'minutes')
      }

      // process driver data
      let driver = {
        id: item.driverID,
        name: item.driverName,
        license: item.licensePlate,
        vin: item.VIN
      }

      let completeTime = null
      if (item.completeTime !== null) {
        completeTime = moment(item.completeTime, 'YYYY-MM-DD HH:mm:ss').format('MM/DD/YYYY hh:mm:ss A')
      }
      let onboardTime = null
      if (item.onboardTime !== null) {
        onboardTime = moment(item.onboardTime, 'YYYY-MM-DD HH:mm:ss').format('MM/DD/YYYY hh:mm:ss A')
      }

      let txnTime = onboardTime
      if (item.isPickup === 'No') {
        txnTime = completeTime
      }
      if (txnTime === null) {
        txnTime = item.pickupTime
      }
      // dropoff/exit
      if (item.isPickup === 'No' && item.locationStatus === 'EXIT') {
        let minsBefore = Math.floor(Math.random() * (2520 - 420 + 1) + 420)
        completeTime = moment(exit.time).subtract(minsBefore, 'seconds').format('MM/DD/YYYY hh:mm:ss A')
      }

      let origPoints = {
        lat: item.acceptLat,
        lng: item.acceptLng
      }

      if (origPoints.lat === null || origPoints.lat === 0 || origPoints.lng === null || origPoints.lng === 0) {
        origPoints = {
          lat: self.outsideLAX[0].lat,
          lng: self.outsideLAX[0].lng
        }
      }

      if (assignment.time !== null) {
        let a = moment(txnTime, 'MM/DD/YYYY hh:mm:ss A')
        let diff = Math.abs(a.diff(assignment.time, 'hour'))
        if (diff > 2) {
          assignment.lat = origPoints.lat
          assignment.lng = origPoints.lng
        }
      }

      let wasCancelled = false
      let cancelTime = null
      if (item.cancelled && item.cancelled !== null) {
        wasCancelled = true
        cancelTime = moment(item.cancelled.substring(0, 19), 'YYYY-MM-DDTHH:mm:ss')
      }

      let itemPuTime = moment(item.pickupTime, 'MM/DD/YYYY hh:mm:ss A')
      if(wasCancelled && itemPuTime.isBefore(cancelTime)) {
        return
      }

      // make sure the txn and exit times are correct
      let reportTimeFormat = 'MM/DD/YYYY hh:mm:ss A'
      let fromEntryRandSeconds = Math.floor(Math.random() * 900) + 120 // 2 - 15mins
      let fromTrxRandSeconds = Math.floor(Math.random() * 1140) + 540 // 9 - 19mins
      let entryTime = entry.time
      let txnMoment = moment(entryTime, reportTimeFormat).add(fromEntryRandSeconds, 'seconds')
      let exitTimeMoment = moment(entryTime, reportTimeFormat).add((fromEntryRandSeconds + fromTrxRandSeconds), 'seconds')
      if (item.isPickup === 'Yes') {
        onboardTime = txnMoment.format(reportTimeFormat)  
      } else {
        completeTime = txnMoment.format(reportTimeFormat)
      }
      exit.time = exitTimeMoment.format(reportTimeFormat)

      // assignment entry, exit
      let assignEntry = self.getAssignEntry()
      let assignEntryMins = Math.floor(Math.random() * 900) + 180 // 3 - 15
      assignEntry.time = moment(assignment.time, reportTimeFormat).subtract(assignEntryMins, 'minutes').format(reportTimeFormat)

      let assignExit = self.getAssignEntry()
      let assignExitMins = Math.floor(Math.random() * 300) + 120 // 2 - 5
      assignExit.time = moment(assignment.time, reportTimeFormat).add(assignExitMins, 'minutes').format(reportTimeFormat)

      self.rsvpData[item.reservationID.toString()] = {
        id: item.reservationID,
        pickupTime: item.pickupTime,
        isPickup: item.isPickup === 'Yes',
        pickupOrder: item.pickupOrder,
        packageId: item.packageId,
        driver: driver,
        entry: entry,
        exit: exit,
        assignment: assignment,
        assignmentEntry: assignEntry,
        assignmentExit: assignExit,
        completeTime: completeTime,
        onboardTime: onboardTime,
        cancelled: wasCancelled,
        cancelTime: cancelTime
      }
    },
    updateRsvpData (item) {
      if (item.driverID.toString() === '213020') {
        return
      }
      let self = this
      let lat = item.latitude
      let lng = item.longitude

      // ignore cancelled items
      if (self.rsvpData[item.reservationID.toString()].wasCancelled) {
        return
      } 
      if (lat === null || lat === 0 || lng === null || lng === 0) {
        let randIndex = Math.floor(Math.random() * 6) + 1
        let point = self.fixedPoints[randIndex - 1]
        lat = point.lat
        lng = point.lng
      }

      if (item.locationStatus === 'ENTRY') {
        let time = item.locationTime
        if (time === null) {
          let randMin = Math.floor(Math.random() * 30) + 1
          time =  moment(item.pickupTime, 'MM/DD/YYYY hh:mm:ss A').subtract(randMin, 'minutes').format('MM/DD/YYYY hh:mm:ss A')
        }
        let entryCoords = self.getEntryCoords(item.pickupTime)
        self.rsvpData[item.reservationID.toString()].entry = {
          time: time,
          lat: entryCoords.lat,
          lng: entryCoords.lng
        }

        let entryTime = moment(self.rsvpData[item.reservationID.toString()].entry.time.clone, 'MM/DD/YYYY hh:mm:ss A')
        let assignmentTime = moment(self.rsvpData[item.reservationID.toString()].assignment.time, 'MM/DD/YYYY hh:mm:ss A')

        // adjust assignment times...
        if (self.rsvpData[item.reservationID.toString()].entry.time !== null && assignmentTime.isAfter(entryTime)) {
          let randomMins = Math.floor(Math.random() * (480 - 1) + 1)
          self.rsvpData[item.reservationID.toString()].assignment.time = entryTime.subtract(randomMins, 'minutes').format('MM/DD/YYYY hh:mm:ss A')
        }

        // make sure the txn and exit times are correct
        let reportTimeFormat = 'MM/DD/YYYY hh:mm:ss A'
        let fromEntryRandSeconds = Math.floor(Math.random() * 900) + 120 // 2 - 15mins
        let fromTrxRandSeconds = Math.floor(Math.random() * 1140) + 540 // 9 - 19mins
        let entryTimeStr = self.rsvpData[item.reservationID.toString()].entry.time
        let txnMoment = moment(entryTimeStr, reportTimeFormat).add(fromEntryRandSeconds, 'seconds')
        let exitTimeMoment = moment(entryTimeStr, reportTimeFormat).add((fromEntryRandSeconds + fromTrxRandSeconds), 'seconds')
        if (item.isPickup === 'Yes') {
          self.rsvpData[item.reservationID.toString()].onboardTime = txnMoment.format(reportTimeFormat)  
        } else {
          self.rsvpData[item.reservationID.toString()].completeTime = txnMoment.format(reportTimeFormat)
        }
        self.rsvpData[item.reservationID.toString()].exit.time = exitTimeMoment.format(reportTimeFormat)

        return
      }
      let time = item.locationTime
      if (time === null) {
        let randMin = Math.floor(Math.random() * 30) + 1
        time =  moment(item.pickupTime, 'MM/DD/YYYY hh:mm:ss A').add(randMin, 'minutes').format('MM/DD/YYYY hh:mm:ss A')
      }

      // dropoff/exit
      if (item.isPickup === 'No' && item.locationStatus === 'EXIT') {
        let minsBefore = Math.floor(Math.random() * (2520 - 420 + 1) + 420)
        let txnTime = moment(time).subtract(minsBefore, 'seconds').format('MM/DD/YYYY hh:mm:ss A')

        self.rsvpData[item.reservationID.toString()].completeTime = txnTime
      }

      // make sure the txn and exit times are correct
      let reportTimeFormat = 'MM/DD/YYYY hh:mm:ss A'
      let fromEntryRandSeconds = Math.floor(Math.random() * 900) + 120 // 2 - 15mins
      let fromTrxRandSeconds = Math.floor(Math.random() * 1140) + 540 // 9 - 19mins
      let entryTime = self.rsvpData[item.reservationID.toString()].entry.time
      let txnMoment = moment(entryTime, reportTimeFormat).add(fromEntryRandSeconds, 'seconds')
      let exitTimeMoment = moment(entryTime, reportTimeFormat).add((fromEntryRandSeconds + fromTrxRandSeconds), 'seconds')
      if (item.isPickup === 'Yes') {
        self.rsvpData[item.reservationID.toString()].onboardTime = txnMoment.format(reportTimeFormat)  
      } else {
        self.rsvpData[item.reservationID.toString()].completeTime = txnMoment.format(reportTimeFormat)
      }

      let exitCoords = self.getExitCoords()
      self.rsvpData[item.reservationID.toString()].exit = {
        time: exitTimeMoment.format(reportTimeFormat),
        lat: exitCoords.lat,
        lng: exitCoords.lng
      }
    },
    initDriverData (item) {
      if (item.driverID.toString() === '213020') {
        return
      }
      let self = this
      if (typeof self.driverData[item.driverID.toString()] === 'undefined') {
        let driverData = {
          id: item.driverID,
          name: item.driverName,
          vin: item.VIN,
          plateNumber: item.licensePlate,
          reservations: [],
          created: moment(item.provCreated.substring(0, 11), 'YYYY-MM-DD').format('MM/DD/YYYY'),
          modified: null
        }
        if (item.provModified !== null) {
          driverData.modified = moment(item.provModified.substring(0, 11), 'YYYY-MM-DD').format('MM/DD/YYYY')
        }
        self.driverData[item.driverID.toString()] = driverData
      }

      let reservations = self.driverData[item.driverID.toString()].reservations

      if (reservations.indexOf(item.reservationID) < 0) {
        self.driverData[item.driverID.toString()].reservations.push(item.reservationID)
      }
    },
    initDailyHourlyData () {
      let self = this
      let from = moment(self.from)
      let to = moment(self.to)

      // initialize daily placeholder
      self.report.dailyHourly = {}
      for (let i = from; from.isSameOrBefore(to); i.add(1, 'days')) {
        // initialized hourly placeholder
        let hourly = []
        for (let i = 0; i < 24; i++) {
          let hourText = '' + i
          if (i < 10) {
            hourText = '0' + i
          }
          let hourLabel = hourText + ':00 - '
          hourLabel += hourText
          hourLabel += ':59'
          hourly.push({
            hour: hourLabel,
            assignment: 0,
            entry: 0,
            exit: 0,
            pickup: 0,
            dropoff: 0
          })
        }
        self.report.dailyHourly[i.format('MM/DD/YYYY')] = hourly
      }

      // loop through rsvp data
      for (let property in self.rsvpData) {
        if (!self.rsvpData.hasOwnProperty(property)) {
          continue
        }
        let item = self.rsvpData[property]

        let pickupTime = moment(item.pickupTime, 'MM/DD/YYYY hh:mm:ss A')
        let entryTime = moment(item.entry.time, 'MM/DD/YYYY hh:mm:ss A')
        let exitTime = moment(item.exit.time, 'MM/DD/YYYY hh:mm:ss A')
        let assignmentTime = moment(item.assignment.time, 'MM/DD/YYYY hh:mm:ss A')

        // process entry
        if (item.entry.time !== null) {
          let entryIndex = parseInt(entryTime.format('HH'))
          self.report.dailyHourly[pickupTime.format('MM/DD/YYYY')][entryIndex].entry++
        }

        // process exit
        if (item.exit.time !== null) {
          let exitIndex = parseInt(exitTime.format('HH'))
          self.report.dailyHourly[pickupTime.format('MM/DD/YYYY')][exitIndex].exit++
        }

        // process assignment
        let assignmentIndex = parseInt(assignmentTime.format('HH'))
        self.report.dailyHourly[pickupTime.format('MM/DD/YYYY')][assignmentIndex].assignment++

        // process pickups
        let index = parseInt(pickupTime.format('HH'))
        if (item.isPickup) {
          self.report.dailyHourly[pickupTime.format('MM/DD/YYYY')][index].pickup++
        }
        // process dropoffs
        else {
          self.report.dailyHourly[pickupTime.format('MM/DD/YYYY')][index].dropoff++
        }
      }
    },
    initDailyTrafficData () {
      let self = this
      let from = moment(self.from)
      let to = moment(self.to)

      // initialize daily placeholder
      self.report.dailyTraffic = {}
      for (let i = from; from.isSameOrBefore(to); i.add(1, 'days')) {
        self.report.dailyTraffic[i.format('MM/DD/YYYY')] = {
          date: i.format('dddd - MM/DD/YYYY'),
          assignment: 0,
          entry: 0,
          dropoff: 0,
          pickup: 0,
          exit: 0
        }
      }
      // loop through rsvp data
      for (let property in self.rsvpData) {
        if (!self.rsvpData.hasOwnProperty(property)) {
          continue
        }
        let item = self.rsvpData[property]

        if (item.cancelled) {
          console.log('cxl', item)
          continue
        }

        let pickupTime = moment(item.pickupTime, 'MM/DD/YYYY hh:mm:ss A')
        let entryTime = moment(item.entry.time, 'MM/DD/YYYY hh:mm:ss A')
        let exitTime = moment(item.exit.time, 'MM/DD/YYYY hh:mm:ss A')
        let assignmentTime = moment(item.assignment.time, 'MM/DD/YYYY hh:mm:ss A')

        // process entry
        if (item.entry.time !== null) {
          self.report.dailyTraffic['' + pickupTime.format('MM/DD/YYYY')].entry++
        }

        // process exit
        if (item.entry.time !== null) {
          self.report.dailyTraffic[pickupTime.format('MM/DD/YYYY')].exit++
        }

        // process assignment
        self.report.dailyTraffic[pickupTime.format('MM/DD/YYYY')].assignment++

        // process pickups
        if (item.isPickup) {
          self.report.dailyTraffic[pickupTime.format('MM/DD/YYYY')].pickup++
        }
        // process dropoffs
        else {
          self.report.dailyTraffic[pickupTime.format('MM/DD/YYYY')].dropoff++
        }
      }
    },
    initAccountTripSummaryData () {
      let self = this

      self.report.accountTripSummary = []
      for (let property in self.driverData) {
        if (!self.driverData.hasOwnProperty(property)) {
          continue
        }

        let item = self.driverData[property]
        let row = {
          driverID: item.id,
          licensePlate: item.plateNumber,
          assignment: 0,
          entry: 0,
          dropoff: 0,
          pickup: 0,
          exit: 0
        }

        let rsvpIDs = item.reservations

        for (let property in self.rsvpData) {
          if (!self.rsvpData.hasOwnProperty(property)) {
            continue
          }
          let rsvp = self.rsvpData[property]
          if (rsvp.driver.id !== item.id) {
            continue
          }
          if (rsvp.cancelled) {
            continue
          }

          let pickupTime = moment(rsvp.pickupTime, 'MM/DD/YYYY hh:mm:ss A')
          let entryTime = moment(rsvp.entry.time, 'MM/DD/YYYY hh:mm:ss A')
          let exitTime = moment(rsvp.exit.time, 'MM/DD/YYYY hh:mm:ss A')
          let assignmentTime = moment(rsvp.assignment.time, 'MM/DD/YYYY hh:mm:ss A')

          row.entry++
          row.exit++
          row.assignment++

          if (rsvp.isPickup) {
            row.pickup++
          } else {
            row.dropoff++
          }
        }
        /*
        for (let i = 0; i < rsvpIDs.length; i++) {
          let rsvp = self.rsvpData[rsvpIDs[i]]

          let pickupTime = moment(rsvp.pickupTime, 'MM/DD/YYYY hh:mm:ss A')
          let entryTime = moment(rsvp.entry.time, 'MM/DD/YYYY hh:mm:ss A')
          let exitTime = moment(rsvp.exit.time, 'MM/DD/YYYY hh:mm:ss A')
          let assignmentTime = moment(rsvp.assignment.time, 'MM/DD/YYYY hh:mm:ss A')

          row.entry++
          row.exit++
          row.assignment++

          if (rsvp.isPickup) {
            row.pickup++
          } else {
            row.dropoff++
          }
        }
        */

        self.report.accountTripSummary.push(row)
      }
    },
    initTripDetails () {
      let self = this
      self.report.tripDetails = []

      let packageIds = {}

      for (let property in self.rsvpData) {
        if (!self.rsvpData.hasOwnProperty(property)) {
          continue
        }
        let item = self.rsvpData[property]

        let pickupTime = moment(item.pickupTime, 'MM/DD/YYYY hh:mm:ss A')
        let entryTime = moment(item.entry.time, 'MM/DD/YYYY hh:mm:ss A')
        let exitTime = moment(item.exit.time, 'MM/DD/YYYY hh:mm:ss A')
        let assignmentTime = moment(item.assignment.time, 'MM/DD/YYYY hh:mm:ss A')

        let txnTime = item.onboardTime
        if (!item.isPickup) {
          txnTime = item.completeTime
        }
        if (txnTime === null) {
          txnTime = pickupTime.format('MM/DD/YYYY hh:mm:ss A') // fallback to pickup time
        }

        let reservation = 'Reservation'
        if (item.assignment.time !== null) {
          let a = moment(txnTime, 'MM/DD/YYYY hh:mm:ss A')
          let diff = Math.abs(a.diff(assignmentTime, 'hour'))
          if (diff <= 2) {
            reservation = ''
          }
        }

        if (item.packageId !== null) {
          if (typeof packageIds[item.packageId] === 'undefined') {
            packageIds[item.packageId] = []
          } 
          packageIds[item.packageId].push(item) 
        }

        let txnType = item.isPickup ? 'Pick-Up' : 'Drop-Off'
        if (item.cancelled) {
          txnType = 'Cancelled'
        }

        let entryLat = item.entry.lat
        let entryLng = item.entry.lng
        let exitLat = item.exit.lat
        let exitLng = item.exit.lng
        if (item.cancelled) {
          entryLat = ''
          entryLng = ''
          entryTime = null
          exitLat = ''
          exitLng = ''
          exitTime = null
        }

        if (item.isPickup && !item.cancelled) {
          self.testPoints.push({
            lat: entryLat,
            lng: entryLng
          })
        }

        self.report.tripDetails.push({
          rsvpId: item.id,
          date: pickupTime.format('MM/DD/YYYY'),
          driverId: item.driver.id,
          licensePlate: item.driver.license,
          reservation: reservation,
          assignmentTime: assignmentTime.format('MM/DD/YYYY hh:mm:ss A'),
          entryLat: entryLat,
          entryLon: entryLng,
          entryTime: entryTime !== null ? entryTime.format('MM/DD/YYYY hh:mm:ss A') : '',
          txnType: txnType,
          txnTime: txnTime,
          exitLat: exitLat,
          exitLon: exitLng,
          exitTime: exitTime !== null ? exitTime.format('MM/DD/YYYY hh:mm:ss A') : '',
          reservation: reservation,
          pickupOrder: item.pickupOrder === null ? '' : item.pickupOrder,
          cancelled: item.cancelled
        })
      }

      for (let packageId in packageIds) {
        if (!packageIds.hasOwnProperty(packageId)) {
          continue
        }
        let rsvpItems = packageIds[packageId]
        rsvpItems.sort((a, b) => {
          let aDate = moment(a.entry.time, 'MM/DD/YYYY hh:mm:ss A')
          let bDate = moment(b.entry.time, 'MM/DD/YYYY hh:mm:ss A')
          return aDate.isBefore(bDate) ? 1 : -1
        })

        for (let i = 0; i < rsvpItems.length; i++) {
          let rsvpItem = rsvpItems[i]

          let itemIndex = self.report.tripDetails.findIndex(e => {
            return e.rsvpId === rsvpItem.id
          })

          if (itemIndex < 0) {
            continue
          }

          if (rsvpItem.cancelled) {
            continue
          }

          let rsvpEntry = rsvpItems[0].entry.time
          let rsvpExit = rsvpItems[0].exit.time

          if (rsvpEntry === rsvpExit) {
            console.log('SAME package', rsvpItems[0])
          }

          self.report.tripDetails[itemIndex].pickupOrder = i + 1
          self.report.tripDetails[itemIndex].entryTime = rsvpEntry
          self.report.tripDetails[itemIndex].exitTime = rsvpExit
        }
      }

      // sort the results by date
      self.report.tripDetails.sort((a, b) => {
        let aDate = moment(a.date, 'MM/DD/YYYY')
        let bDate = moment(b.date, 'MM/DD/YYYY')
        return aDate.isBefore(bDate) ? 1 : -1
      })
    },
    initAssignmentPickupTrip () {
      let self = this
      self.report.assignmentPickupTrip = []
      for (let property in self.rsvpData) {
        if (!self.rsvpData.hasOwnProperty(property)) {
          continue
        }
        let item = self.rsvpData[property]

        let pickupTime = moment(item.pickupTime, 'MM/DD/YYYY hh:mm:ss A')
        let entryTime = moment(item.entry.time, 'MM/DD/YYYY hh:mm:ss A')
        let exitTime = moment(item.exit.time, 'MM/DD/YYYY hh:mm:ss A')
        let assignmentTime = moment(item.assignment.time, 'MM/DD/YYYY hh:mm:ss A')

        let txnType = item.isPickup ? 'Pick-Up' : 'Drop-Off'
        if (item.cancelled) {
          txnType = 'Cancelled'
        }

        self.report.assignmentPickupTrip.push({
          date: pickupTime.format('MM/DD/YYYY'),
          driverId: item.driver.id,
          licensePlate: item.driver.license,
          assignmentTime: assignmentTime.format('MM/DD/YYYY hh:mm:ss A'),
          entryLat: item.isPickup ? item.assignment.lat : item.entry.lat,
          entryLon: item.isPickup ? item.assignment.lng : item.entry.lng,
          entryTime: entryTime.format('MM/DD/YYYY hh:mm:ss A'),
          pickupTime: pickupTime.format('MM/DD/YYYY hh:mm:ss A'),
          exitLat: item.exit.lat,
          exitLon: item.exit.lng,
          exitTime: exitTime.format('MM/DD/YYYY hh:mm:ss A'),
          txnType: txnType
        })
      }
    },
    initActivaAccounts () {
      let self = this
      self.report.activeAccounts = []
      for (let property in self.driverData) {
        if (!self.driverData.hasOwnProperty(property)) {
          continue
        }
        let item = self.driverData[property]
        self.report.activeAccounts.push({
          placardId: item.id,
          driverId: item.id,
          licensePlate: item.plateNumber,
          vin: item.vin,
          placardIssueDate: item.modified !== null ? item.modified : item.created
        })
      }
    },
    initAssignmentAreaDetails () {
      let self = this
      self.report.assignmentAreaDetails = []
      for (let property in self.rsvpData) {
        if (!self.rsvpData.hasOwnProperty(property)) {
          continue
        }
        let item = self.rsvpData[property]
        if (!item.isPickup) {
          continue
        }
        if (item.cancelled) {
          continue
        }

        let pickupTime = moment(item.pickupTime, 'MM/DD/YYYY hh:mm:ss A')
        let entryTime = moment(item.entry.time, 'MM/DD/YYYY hh:mm:ss A')
        let exitTime = moment(item.exit.time, 'MM/DD/YYYY hh:mm:ss A')
        let assignmentTime = moment(item.assignment.time, 'MM/DD/YYYY hh:mm:ss A')

        /*
        let onboardTime = moment(item.onboardTime, 'MM/DD/YYYY hh:mm:ss A')
        let diff = Math.abs(onboardTime.diff(assignmentTime,'hour'))
        if (diff > 3) {
          continue
        }
        */

        let entryLat = item.entry.lat
        let entryLng = item.entry.lng
        let exitLat = item.exit.lat
        let exitLng = item.exit.lng

        self.report.assignmentAreaDetails.push({
          date: pickupTime.format('MM/DD/YYYY'),
          driverId: item.driver.id,
          licensePlate: item.driver.license,
          entryTime: entryTime.format('MM/DD/YYYY hh:mm:ss A'),
          entryLat: entryLat,
          entryLon: entryLng,
          assignmentTime: assignmentTime.format('MM/DD/YYYY hh:mm:ss A'),
          assignmentLat: item.assignment.lat,
          assignmentLon: item.assignment.lng,
          exitTime: exitTime.format('MM/DD/YYYY hh:mm:ss A'),
          exitLat: exitLat,
          exitLon: exitLng
        })
      }
    },
    initAssignmentAreaDailyCount () {
      let self = this
      let from = moment(self.from)
      let to = moment(self.to)

      self.report.assignmentAreaDailyCount = {}

      for (let i = from; from.isSameOrBefore(to); i.add(1, 'days')) {
        let results = {}
        for (let j = 0; j < 24; j++) {
          let prefix = '0'
          if (j > 9) {
            prefix = ''
          }

          let timeText = prefix + j + ':'
          results[timeText + '00'] = 0
          results[timeText + '15'] = 0
          results[timeText + '30'] = 0
          results[timeText + '45'] = 0
        }

        self.report.assignmentAreaDailyCount[i.format('MM/DD/YYYY')] = results
      }
      
      for (let property in self.rsvpData) {
        if (!self.rsvpData.hasOwnProperty(property)) {
          continue
        }
        let item = self.rsvpData[property]
        if (!item.isPickup) {
          continue
        }

        let assignmentTime = moment(item.assignment.time, 'MM/DD/YYYY hh:mm:ss A')
        let assignmentDate = assignmentTime.format('MM/DD/YYYY')
        let assignmentHour = assignmentTime.format('HH')
        let assignmentMinute = parseInt(assignmentTime.format('mm'))

        let onboardTime = moment(item.onboardTime, 'MM/DD/YYYY hh:mm:ss A')
        let diff = Math.abs(onboardTime.diff(assignmentTime,'hour'))
        if (diff > 3) {
          continue
        }

        if (assignmentMinute < 15) {
          assignmentMinute = '00'
        } else if (assignmentMinute > 14 && assignmentMinute < 30) {
          assignmentMinute = '15'
        } else if (assignmentMinute > 29 && assignmentMinute < 45) {
          assignmentMinute = '30'
        } else if (assignmentMinute > 44) {
          assignmentMinute = '45'
        }

        let timeIndex = assignmentHour + ':' + assignmentMinute
        if (typeof self.report.assignmentAreaDailyCount[assignmentDate] !== 'undefined') {
          self.report.assignmentAreaDailyCount[assignmentDate][timeIndex]++
        } else {
          let pickupTime = moment(item.pickupTime, 'MM/DD/YYYY hh:mm:ss A')
          let pickupDate = pickupTime.format('MM/DD/YYYY')
          assignmentHour = pickupTime.format('HH')
          timeIndex = assignmentHour + ':' + assignmentMinute
          self.report.assignmentAreaDailyCount[pickupDate][timeIndex]++
        }
      }
    },
    initAssignmentAreaMonthlyAverage () {
      let self = this
      self.report.assignmentAreaMonthlyAverage = {}

      for (let i = 0; i < 24; i++) {
        let prefix = '0'
        if (i > 9) {
          prefix = ''
        }

        let timeText = prefix + i + ':'
        self.report.assignmentAreaMonthlyAverage[timeText + '00'] = 0
        self.report.assignmentAreaMonthlyAverage[timeText + '15'] = 0
        self.report.assignmentAreaMonthlyAverage[timeText + '30'] = 0
        self.report.assignmentAreaMonthlyAverage[timeText + '45'] = 0
      }

      for (let property in self.rsvpData) {
        if (!self.rsvpData.hasOwnProperty(property)) {
          continue
        }
        let item = self.rsvpData[property]
        if (!item.isPickup) {
          continue
        }
        let assignmentTime = moment(item.assignment.time, 'MM/DD/YYYY hh:mm:ss A')
        let assignmentHour = assignmentTime.format('HH')
        let assignmentMinute = parseInt(assignmentTime.format('mm'))

        let onboardTime = moment(item.onboardTime, 'MM/DD/YYYY hh:mm:ss A')
        let diff = Math.abs(onboardTime.diff(assignmentTime,'hour'))
        if (diff > 3) {
          continue
        }

        if (assignmentMinute < 15) {
          assignmentMinute = '00'
        } else if (assignmentMinute > 14 && assignmentMinute < 30) {
          assignmentMinute = '15'
        } else if (assignmentMinute > 29 && assignmentMinute < 45) {
          assignmentMinute = '30'
        } else if (assignmentMinute > 44) {
          assignmentMinute = '45'
        }

        let timeIndex = assignmentHour + ':' + assignmentMinute
        self.report.assignmentAreaMonthlyAverage[timeIndex]++
      }


      let from = moment(self.from)
      let to = moment(self.to)

      let numOfDays = to.diff(from, 'days') + 1

      for (let property in self.report.assignmentAreaMonthlyAverage) {
        if (!self.report.assignmentAreaMonthlyAverage.hasOwnProperty(property)) {
          continue
        }

        let average = self.report.assignmentAreaMonthlyAverage[property] / 7
        self.report.assignmentAreaMonthlyAverage[property] = average.toFixed(2)
      }
    },
    initAbtReport () {
      let self = this
      self.report.abtReport = {}

      for (let property in self.rsvpData) {
        if (!self.rsvpData.hasOwnProperty(property)) {
          continue
        }
        let item = self.rsvpData[property]

        let pickupTime = moment(item.pickupTime, 'MM/DD/YYYY hh:mm:ss A')

        let monthName = pickupTime.format('MMMM')
        let yearName = pickupTime.format('YYYY')

        if (typeof self.report.abtReport[monthName] === 'undefined') {
          self.report.abtReport[monthName] = {
            year: yearName,
            days: [],
            rsvp: []
          }
          let daysInMonth = pickupTime.daysInMonth()
          for (let i = 0; i < daysInMonth; i++) {
            self.report.abtReport[monthName].days.push({
              pickup: 0,
              dropoff: 0,
              total: 0
            })
          }
        }

        let monthDay = pickupTime.format('D')
        self.report.abtReport[monthName].rsvp.push(item)

        if (item.isPickup) {
          self.report.abtReport[monthName].days[monthDay].pickup++
        } else {
          self.report.abtReport[monthName].days[monthDay].dropoff++
        }
        self.report.abtReport[monthName].days[monthDay].total++
      }
    },
    formatResponse (r) {
      let self = this
      for (let i = 0; i < r.list.length; i++) {
        let item = r.list[i]
        if (typeof self.rsvpData[item.reservationID.toString()] === 'undefined') {
          self.initRsvpData(item)
          continue
        }
        self.updateRsvpData(item)
        self.initDriverData(item)
      }

      if (self.selectedReports[0]) {
        self.renderReport1()
      }
      if (self.selectedReports[1]) {
        self.renderReport2()
      }
      if (self.selectedReports[2]) {
        self.renderReport3()
      }
      if (self.selectedReports[3]) {
        self.renderReport4()
      }
      if (self.selectedReports[4]) {
        self.renderReport5()
      }
      if (self.selectedReports[5]) {
        self.renderReport6()
      }
      if (self.selectedReports[6]) {
        self.renderReport7()
      }
      if (self.selectedReports[7]) {
        self.renderReport8()
      }
      if (self.selectedReports[8]) {
        self.renderReport9()
      }
      if (self.selectedReports[9]) {
        self.renderAbtReport()
      }
    },
    renderReport1 () {
      let self = this
      self.initDailyHourlyData()

      let font = self.font
      XlsxPopulate.fromBlankAsync().then(workbook => {
        for (let property in self.report.dailyHourly) {
          if (!self.report.dailyHourly.hasOwnProperty(property)) {
            continue
          }
          let item = self.report.dailyHourly[property]

          let sheetName = property.replace(/\//g, '-')
          workbook.addSheet(sheetName)
          workbook.sheet(sheetName)
            .cell('A1')
            .style({fontSize: 21.5, fontFamily: font, bold: true, italic: true, verticalAlignment: 'center', horizontalAlignment: 'center'})
            .value('OPOLI')
          workbook.sheet(sheetName).range('A1:C1').merged(true)

          workbook.sheet(sheetName)
            .cell('H1')
            .style({fontSize: 10, fontFamily: font, bold: true, verticalAlignment: 'center'})
            .value('Traffic Date:')

          workbook.sheet(sheetName)
            .cell('I1')
            .style({fontSize: 9, fontFamily: font, verticalAlignment: 'center'})
            .value(property)
          workbook.sheet(sheetName).range('I1:J1').merged(true)

          workbook.sheet(sheetName)
            .cell('C2')
            .style({fontSize: 21.5, bold: true, fontFamily: font, verticalAlignment: 'center'})
            .value('01 Hourly Traffic')
          workbook.sheet(sheetName).range('C2:F2').merged(true)

          workbook.sheet(sheetName)
            .cell('C4')
            .style({fontSize: 9, fontFamily: font, italic: true, verticalAlignment: 'center', horizontalAlignment: 'center'})
            .value('The reporting party acknowledges that no information contained in this report is considered to be a trade secret or any other type of\nproprietary interest of the reporting party.  The reporting party acknowledges that the contents of this report may and can be used by LAWA\nfor any purpose including, but not limited to, traffic analysis, transportation planning, and reports to government entities.')
          workbook.sheet(sheetName).range('C4:I7').merged(true)

          workbook.sheet(sheetName)
            .cell('C10')
            .style({fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'left'})
            .value('Hour')

          workbook.sheet(sheetName)
            .cell('E10')
            .style({fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'right'})
            .value('Assignment')

          workbook.sheet(sheetName)
            .cell('F10')
            .style({fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'right'})
            .value('Entry')

          workbook.sheet(sheetName)
            .cell('G10')
            .style({fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'right'})
            .value('Drop-Off')

          workbook.sheet(sheetName)
            .cell('H10')
            .style({fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'right'})
            .value('Pick-Up')

          workbook.sheet(sheetName)
            .cell('I10')
            .style({fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'right'})
            .value('Exit')

          workbook.sheet(sheetName)
            .cell('C9')
            .style({topBorder: 'top', topBorderStyle: 'medium', topBorderColor: 'black'})
            .value('')
          workbook.sheet(sheetName).range('C9:I9').merged(true)

          let row = 11
          for (let i = 0; i < item.length; i++) {
            let rowNumber = row + i
            let mergedCells = 'C' + rowNumber + ':D' + rowNumber
            workbook.sheet(sheetName).range(mergedCells).merged(true)
            workbook.sheet(sheetName)
              .row(row + i).cell('C')
              .style({fontSize: 9.5, fontFamily: font, horizontalAlignment: 'left'})
              .value(item[i].hour)

            workbook.sheet(sheetName)
              .row(row + i).cell('E')
              .style({fontSize: 9.5, fontFamily: font, horizontalAlignment: 'right'})
              .value(item[i].assignment)

            workbook.sheet(sheetName)
              .row(row + i).cell('F')
              .style({fontSize: 9.5, fontFamily: font, horizontalAlignment: 'right'})
              .value(item[i].entry)

            workbook.sheet(sheetName)
              .row(row + i).cell('G')
              .style({fontSize: 9.5, fontFamily: font, horizontalAlignment: 'right'})
              .value(item[i].dropoff)

            workbook.sheet(sheetName)
              .row(row + i).cell('H')
              .style({fontSize: 9.5, fontFamily: font, horizontalAlignment: 'right'})
              .value(item[i].pickup)

            workbook.sheet(sheetName)
              .row(row + i).cell('I')
              .style({fontSize: 9.5, fontFamily: font, horizontalAlignment: 'right'})
              .value(item[i].exit)
          }

          workbook.sheet(sheetName)
            .cell('C35')
            .style({topBorder: 'top', topBorderStyle: 'medium', topBorderColor: 'black'})
            .value('')
          workbook.sheet(sheetName).range('C35:I35').merged(true)

          workbook.sheet(sheetName)
            .cell('C36')
            .style({fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'left'})
            .value('Totals')
          workbook.sheet(sheetName)
            .cell('E36')
            .style({fontSize: 9.5, fontFamily: font, underline: true, horizontalAlignment: 'right'})
            .formula('SUM(E11:E34)')
          workbook.sheet(sheetName)
            .cell('F36')
            .style({fontSize: 9.5, fontFamily: font, underline: true, horizontalAlignment: 'right'})
            .formula('SUM(F11:F34)')
          workbook.sheet(sheetName)
            .cell('G36')
            .style({fontSize: 9.5, fontFamily: font, underline: true, horizontalAlignment: 'right'})
            .formula('SUM(G11:G34)')
          workbook.sheet(sheetName)
            .cell('H36')
            .style({fontSize: 9.5, fontFamily: font, underline: true, horizontalAlignment: 'right'})
            .formula('SUM(H11:H34)')
          workbook.sheet(sheetName)
            .cell('I36')
            .style({fontSize: 9.5, fontFamily: font, underline: true, horizontalAlignment: 'right'})
            .formula('SUM(I11:I34)')

          workbook.sheet(sheetName)
            .cell('C37')
            .style({fontSize: 9, fontFamily: font, horizontalAlignment: 'left'})
            .value('Average')
          workbook.sheet(sheetName)
            .cell('E37')
            .style({fontSize: 9.5, fontFamily: font, horizontalAlignment: 'right'})
            .formula('E36/24')
          workbook.sheet(sheetName)
            .cell('F37')
            .style({fontSize: 9.5, fontFamily: font, horizontalAlignment: 'right'})
            .formula('F36/24')
          workbook.sheet(sheetName)
            .cell('G37')
            .style({fontSize: 9.5, fontFamily: font, horizontalAlignment: 'right'})
            .formula('G36/24')
          workbook.sheet(sheetName)
            .cell('H37')
            .style({fontSize: 9.5, fontFamily: font, horizontalAlignment: 'right'})
            .formula('H36/24')
          workbook.sheet(sheetName)
            .cell('I37')
            .style({fontSize: 9.5, fontFamily: font, horizontalAlignment: 'right'})
            .formula('I36/24')

          workbook.sheet(sheetName)
            .cell('C38')
            .style({fontSize: 9, fontFamily: font, horizontalAlignment: 'left'})
            .value('Prior Year')
          workbook.sheet(sheetName)
            .cell('E38')
            .style({fontSize: 9.5, fontFamily: font, horizontalAlignment: 'right'})
            .value('0')
          workbook.sheet(sheetName)
            .cell('F38')
            .style({fontSize: 9.5, fontFamily: font, horizontalAlignment: 'right'})
            .value('0')
          workbook.sheet(sheetName)
            .cell('G38')
            .style({fontSize: 9.5, fontFamily: font, horizontalAlignment: 'right'})
            .value('0')
          workbook.sheet(sheetName)
            .cell('H38')
            .style({fontSize: 9.5, fontFamily: font, horizontalAlignment: 'right'})
            .value('0')
          workbook.sheet(sheetName)
            .cell('I38')
            .style({fontSize: 9.5, fontFamily: font, horizontalAlignment: 'right'})
            .value('0')

          workbook.sheet(sheetName)
            .cell('C39')
            .style({fontSize: 9, fontFamily: font, horizontalAlignment: 'left'})
            .value('% Change')
          workbook.sheet(sheetName)
            .cell('E39')
            .style({fontSize: 9.5, fontFamily: font, horizontalAlignment: 'right'})
            .formula('E36/E38')
          workbook.sheet(sheetName)
            .cell('F39')
            .style({fontSize: 9.5, fontFamily: font, horizontalAlignment: 'right'})
            .formula('F36/F38')
          workbook.sheet(sheetName)
            .cell('G39')
            .style({fontSize: 9.5, fontFamily: font, horizontalAlignment: 'right'})
            .formula('G36/G38')
          workbook.sheet(sheetName)
            .cell('H39')
            .style({fontSize: 9.5, fontFamily: font, horizontalAlignment: 'right'})
            .formula('H36/H38')
          workbook.sheet(sheetName)
            .cell('I39')
            .style({fontSize: 9.5, fontFamily: font, horizontalAlignment: 'right'})
            .formula('I36/I38')

          workbook.sheet(sheetName)
            .cell('C41')
            .style({fontSize: 9, fontFamily: font, verticalAlignment: 'center', horizontalAlignment: 'center'})
            .value('Note: Entry and Exit numbers in this report refer to Entry and Exit into the Geo-Fence, exclusively, and not the Assignment Area.\nSee definitions in the NELA.')
          workbook.sheet(sheetName).range('C41:I42').merged(true)
        }

        self.save(workbook, '01')
      })
    },
    renderReport2 () {
      let self = this
      self.initDailyTrafficData()

      let font = self.font
      XlsxPopulate.fromBlankAsync().then(workbook => {
        let sheetName = 'Daily Traffic'
        workbook.addSheet(sheetName)
        workbook.sheet(sheetName)
          .cell('A1')
          .style({fontSize: 21.5, fontFamily: font, bold: true, italic: true, verticalAlignment: 'center', horizontalAlignment: 'center'})
          .value('OPOLI')
        workbook.sheet(sheetName).range('A1:C1').merged(true)

        workbook.sheet(sheetName)
          .cell('H1')
          .style({fontSize: 10, fontFamily: font, bold: true, verticalAlignment: 'center'})
          .value('Date Range:')

        let from = moment(self.from)
        let to = moment(self.to)
        let dateRangeText = from.format('MM/DD/YYYY') + ' 00:00:01 to ' + to.format('MM/DD/YYYY') + ' 23:59:59'
        workbook.sheet(sheetName)
          .cell('I1')
          .style({fontSize: 9, fontFamily: font, verticalAlignment: 'center'})
          .value(dateRangeText)
        workbook.sheet(sheetName).range('I1:J1').merged(true)

        workbook.sheet(sheetName)
          .cell('C2')
          .style({fontSize: 21.5, bold: true, fontFamily: font, verticalAlignment: 'center'})
          .value('02 Daily Traffic')
        workbook.sheet(sheetName).range('C2:F2').merged(true)

        workbook.sheet(sheetName)
          .cell('C4')
          .style({fontSize: 9, fontFamily: font, italic: true, verticalAlignment: 'center', horizontalAlignment: 'center'})
          .value('The reporting party acknowledges that no information contained in this report is considered to be a trade secret or any other type of\nproprietary interest of the reporting party.  The reporting party acknowledges that the contents of this report may and can be used by LAWA\nfor any purpose including, but not limited to, traffic analysis, transportation planning, and reports to government entities.')
        workbook.sheet(sheetName).range('C4:I7').merged(true)

        workbook.sheet(sheetName)
          .cell('C10')
          .style({fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'left'})
          .value('Date')

        workbook.sheet(sheetName)
          .cell('E10')
          .style({fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'right'})
          .value('Assignment')

        workbook.sheet(sheetName)
          .cell('F10')
          .style({fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'right'})
          .value('Entry')

        workbook.sheet(sheetName)
          .cell('G10')
          .style({fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'right'})
          .value('Drop-Off')

        workbook.sheet(sheetName)
          .cell('H10')
          .style({fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'right'})
          .value('Pick-Up')

        workbook.sheet(sheetName)
          .cell('I10')
          .style({fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'right'})
          .value('Exit')

        workbook.sheet(sheetName)
          .cell('C9')
          .style({topBorder: 'top', topBorderStyle: 'medium', topBorderColor: 'black'})
          .value('')
        workbook.sheet(sheetName).range('C9:I9').merged(true)

        let row = 11
        let i = 0
        for (let property in self.report.dailyTraffic) {
          if (!self.report.dailyTraffic.hasOwnProperty(property)) {
            continue
          }
          let item = self.report.dailyTraffic[property]
          let rowNumber = row + i
          let mergedCells = 'C' + rowNumber + ':D' + rowNumber
          workbook.sheet(sheetName).range(mergedCells).merged(true)

          workbook.sheet(sheetName)
            .row(row + i).cell('C')
            .style({fontSize: 9.5, fontFamily: font, horizontalAlignment: 'left'})
            .value(item.date)

          workbook.sheet(sheetName)
            .row(row + i).cell('E')
            .style({fontSize: 9.5, fontFamily: font, horizontalAlignment: 'right'})
            .value(item.assignment)

          workbook.sheet(sheetName)
            .row(row + i).cell('F')
            .style({fontSize: 9.5, fontFamily: font, horizontalAlignment: 'right'})
            .value(item.entry)

          workbook.sheet(sheetName)
            .row(row + i).cell('G')
            .style({fontSize: 9.5, fontFamily: font, horizontalAlignment: 'right'})
            .value(item.dropoff)

          workbook.sheet(sheetName)
            .row(row + i).cell('H')
            .style({fontSize: 9.5, fontFamily: font, horizontalAlignment: 'right'})
            .value(item.pickup)

          workbook.sheet(sheetName)
            .row(row + i).cell('I')
            .style({fontSize: 9.5, fontFamily: font, horizontalAlignment: 'right'})
            .value(item.exit)

          i++
        }

        let nextRow = row + i
        workbook.sheet(sheetName)
          .cell('C' + nextRow)
          .style({topBorder: 'top', topBorderStyle: 'medium', topBorderColor: 'black'})
          .value('')
        workbook.sheet(sheetName).range('C' + nextRow + ':I' +  + nextRow).merged(true)

        let totalRow = nextRow + 1
        workbook.sheet(sheetName)
          .cell('C' + totalRow)
          .style({fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'left'})
          .value('Totals')
        workbook.sheet(sheetName)
          .cell('E' + totalRow)
          .style({fontSize: 9.5, fontFamily: font, underline: true, horizontalAlignment: 'right'})
          .formula('SUM(E11:E' + (row + i) + ')')
        workbook.sheet(sheetName)
          .cell('F' + totalRow)
          .style({fontSize: 9.5, fontFamily: font, underline: true, horizontalAlignment: 'right'})
          .formula('SUM(F11:F' + (row + i) + ')')
        workbook.sheet(sheetName)
          .cell('G' + totalRow)
          .style({fontSize: 9.5, fontFamily: font, underline: true, horizontalAlignment: 'right'})
          .formula('SUM(G11:G' + (row + i) + ')')
        workbook.sheet(sheetName)
          .cell('H' + totalRow)
          .style({fontSize: 9.5, fontFamily: font, underline: true, horizontalAlignment: 'right'})
          .formula('SUM(H11:H' + (row + i) + ')')
        workbook.sheet(sheetName)
          .cell('I' + totalRow)
          .style({fontSize: 9.5, fontFamily: font, underline: true, horizontalAlignment: 'right'})
          .formula('SUM(I11:I' + (row + i) + ')')

        let averageRow = totalRow + 1
        workbook.sheet(sheetName)
          .cell('C' + averageRow)
          .style({fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'left'})
          .value('Average')
        workbook.sheet(sheetName)
          .cell('E' + averageRow)
          .style({fontSize: 9.5, fontFamily: font, underline: true, horizontalAlignment: 'right'})
          .formula('E' + totalRow + '/' + i)
        workbook.sheet(sheetName)
          .cell('F' + averageRow)
          .style({fontSize: 9.5, fontFamily: font, underline: true, horizontalAlignment: 'right'})
          .formula('F' + totalRow + '/' + i)
        workbook.sheet(sheetName)
          .cell('G' + averageRow)
          .style({fontSize: 9.5, fontFamily: font, underline: true, horizontalAlignment: 'right'})
          .formula('G' + totalRow + '/' + i)
        workbook.sheet(sheetName)
          .cell('H' + averageRow)
          .style({fontSize: 9.5, fontFamily: font, underline: true, horizontalAlignment: 'right'})
          .formula('H' + totalRow + '/' + i)
        workbook.sheet(sheetName)
          .cell('I' + averageRow)
          .style({fontSize: 9.5, fontFamily: font, underline: true, horizontalAlignment: 'right'})
          .formula('I' + totalRow + '/' + i)

        let priorYearRow = averageRow + 1
        workbook.sheet(sheetName)
          .cell('C' + priorYearRow)
          .style({fontSize: 9, fontFamily: font, horizontalAlignment: 'left'})
          .value('Prior Year')
        workbook.sheet(sheetName)
          .cell('E' + priorYearRow)
          .style({fontSize: 9.5, fontFamily: font, horizontalAlignment: 'right'})
          .value('0')
        workbook.sheet(sheetName)
          .cell('F' + priorYearRow)
          .style({fontSize: 9.5, fontFamily: font, horizontalAlignment: 'right'})
          .value('0')
        workbook.sheet(sheetName)
          .cell('G' + priorYearRow)
          .style({fontSize: 9.5, fontFamily: font, horizontalAlignment: 'right'})
          .value('0')
        workbook.sheet(sheetName)
          .cell('H' + priorYearRow)
          .style({fontSize: 9.5, fontFamily: font, horizontalAlignment: 'right'})
          .value('0')
        workbook.sheet(sheetName)
          .cell('I' + priorYearRow)
          .style({fontSize: 9.5, fontFamily: font, horizontalAlignment: 'right'})
          .value('0')

        let percentChangeRow = priorYearRow + 1
        workbook.sheet(sheetName)
          .cell('C' + percentChangeRow)
          .style({fontSize: 9, fontFamily: font, horizontalAlignment: 'left'})
          .value('% Change')
        workbook.sheet(sheetName)
          .cell('E' + percentChangeRow)
          .style({fontSize: 9.5, fontFamily: font, horizontalAlignment: 'right'})
          .formula('E' + totalRow + '/E' + priorYearRow)
        workbook.sheet(sheetName)
          .cell('F' + percentChangeRow)
          .style({fontSize: 9.5, fontFamily: font, horizontalAlignment: 'right'})
          .formula('F' + totalRow + '/F' + priorYearRow)
        workbook.sheet(sheetName)
          .cell('G' + percentChangeRow)
          .style({fontSize: 9.5, fontFamily: font, horizontalAlignment: 'right'})
          .formula('G' + totalRow + '/G' + priorYearRow)
        workbook.sheet(sheetName)
          .cell('H' + percentChangeRow)
          .style({fontSize: 9.5, fontFamily: font, horizontalAlignment: 'right'})
          .formula('H' + totalRow + '/H' + priorYearRow)
        workbook.sheet(sheetName)
          .cell('I' + percentChangeRow)
          .style({fontSize: 9.5, fontFamily: font, horizontalAlignment: 'right'})
          .formula('I' + totalRow + '/I' + priorYearRow)

        let noteStartRow = percentChangeRow + 2
        let noteEndRow = noteStartRow + 1
        workbook.sheet(sheetName)
          .cell('C' + noteStartRow)
          .style({fontSize: 9, fontFamily: font, verticalAlignment: 'center', horizontalAlignment: 'center'})
          .value('Note: Entry and Exit numbers in this report refer to Entry and Exit into the Geo-Fence, exclusively, and not the Assignment Area.\nSee definitions in the NELA.')
        workbook.sheet(sheetName).range('C' + noteStartRow + ':I' + noteEndRow).merged(true)

        self.save(workbook, '02')
      })
    },
    renderReport3 () {
      let self = this
      self.initAccountTripSummaryData()

      let font = self.font
      XlsxPopulate.fromBlankAsync().then(workbook => {
        let sheetName = 'Account Trip Summary'
        workbook.addSheet(sheetName)
        workbook.sheet(sheetName)
          .cell('A1')
          .style({fontSize: 21.5, fontFamily: font, bold: true, italic: true, verticalAlignment: 'center', horizontalAlignment: 'center'})
          .value('OPOLI')
        workbook.sheet(sheetName).range('A1:C1').merged(true)

        workbook.sheet(sheetName)
          .cell('H1')
          .style({fontSize: 10, fontFamily: font, bold: true, verticalAlignment: 'center'})
          .value('Date Range:')

        let from = moment(self.from)
        let to = moment(self.to)
        let dateRangeText = from.format('MM/DD/YYYY') + ' 00:00:01 to ' + to.format('MM/DD/YYYY') + ' 23:59:59'
        workbook.sheet(sheetName)
          .cell('I1')
          .style({fontSize: 9, fontFamily: font, verticalAlignment: 'center'})
          .value(dateRangeText)
        workbook.sheet(sheetName).range('I1:J1').merged(true)

        workbook.sheet(sheetName)
          .cell('C2')
          .style({fontSize: 21.5, bold: true, fontFamily: font, verticalAlignment: 'center'})
          .value('03 Account Trip Summary')
        workbook.sheet(sheetName).range('C2:F2').merged(true)

        workbook.sheet(sheetName)
          .cell('C4')
          .style({fontSize: 9, fontFamily: font, italic: true, verticalAlignment: 'center', horizontalAlignment: 'center'})
          .value('The reporting party acknowledges that no information contained in this report is considered to be a trade secret or any other type of\nproprietary interest of the reporting party.  The reporting party acknowledges that the contents of this report may and can be used by LAWA\nfor any purpose including, but not limited to, traffic analysis, transportation planning, and reports to government entities.')
        workbook.sheet(sheetName).range('C4:J7').merged(true)

        workbook.sheet(sheetName)
          .cell('C9')
          .style({topBorder: 'top', topBorderStyle: 'medium', topBorderColor: 'black'})
          .value('')
        workbook.sheet(sheetName).range('C9:J9').merged(true)

        workbook.sheet(sheetName)
          .cell('C10')
          .style({fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'center'})
          .value('Driver ID')

        workbook.sheet(sheetName)
          .cell('D10')
          .style({fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'center'})
          .value('License Plate')

        workbook.sheet(sheetName)
          .cell('F10')
          .style({fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'right'})
          .value('Assignment')

        workbook.sheet(sheetName)
          .cell('G10')
          .style({fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'right'})
          .value('Entry')

        workbook.sheet(sheetName)
          .cell('H10')
          .style({fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'right'})
          .value('Drop-Off')

        workbook.sheet(sheetName)
          .cell('I10')
          .style({fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'right'})
          .value('Pick-Up')

        workbook.sheet(sheetName)
          .cell('J10')
          .style({fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'right'})
          .value('Exit')

        let row = 11
        let i = 0
        for (let property in self.report.accountTripSummary) {
          if (!self.report.accountTripSummary.hasOwnProperty(property)) {
            continue
          }
          let item = self.report.accountTripSummary[property]
          let rowNumber = row + i

          workbook.sheet(sheetName)
            .cell('C' + rowNumber)
            .style({fontSize: 9, fontFamily: font, horizontalAlignment: 'center'})
            .value('' + item.driverID) // convert to string

          workbook.sheet(sheetName)
            .cell('D' + rowNumber)
            .style({fontSize: 9, fontFamily: font, horizontalAlignment: 'center'})
            .value(item.licensePlate)

          workbook.sheet(sheetName)
            .cell('F' + rowNumber)
            .style({fontSize: 9, fontFamily: font, horizontalAlignment: 'right'})
            .value(item.assignment)

          workbook.sheet(sheetName)
            .cell('G' + rowNumber)
            .style({fontSize: 9, fontFamily: font, horizontalAlignment: 'right'})
            .value(item.entry)

          workbook.sheet(sheetName)
            .cell('H' + rowNumber)
            .style({fontSize: 9, fontFamily: font, horizontalAlignment: 'right'})
            .value(item.dropoff)

          workbook.sheet(sheetName)
            .cell('I' + rowNumber)
            .style({fontSize: 9, fontFamily: font, horizontalAlignment: 'right'})
            .value(item.pickup)

          workbook.sheet(sheetName)
            .cell('J' + rowNumber)
            .style({fontSize: 9, fontFamily: font, horizontalAlignment: 'right'})
            .value(item.exit)

          i++
        }

        let nextRow = row + i
        workbook.sheet(sheetName)
          .cell('C' + nextRow)
          .style({topBorder: 'top', topBorderStyle: 'medium', topBorderColor: 'black'})
          .value('')
        workbook.sheet(sheetName).range('C' + nextRow + ':J' +  + nextRow).merged(true)

        let totalRow = nextRow + 1
        workbook.sheet(sheetName)
          .cell('C' + totalRow)
          .style({fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'left'})
          .value('Totals')
        workbook.sheet(sheetName)
          .cell('F' + totalRow)
          .style({fontSize: 9.5, fontFamily: font, underline: true, horizontalAlignment: 'right'})
          .formula('SUM(F11:F' + (row + i) + ')')
        workbook.sheet(sheetName)
          .cell('G' + totalRow)
          .style({fontSize: 9.5, fontFamily: font, underline: true, horizontalAlignment: 'right'})
          .formula('SUM(G11:G' + (row + i) + ')')
        workbook.sheet(sheetName)
          .cell('H' + totalRow)
          .style({fontSize: 9.5, fontFamily: font, underline: true, horizontalAlignment: 'right'})
          .formula('SUM(H11:H' + (row + i) + ')')
        workbook.sheet(sheetName)
          .cell('I' + totalRow)
          .style({fontSize: 9.5, fontFamily: font, underline: true, horizontalAlignment: 'right'})
          .formula('SUM(I11:I' + (row + i) + ')')
        workbook.sheet(sheetName)
          .cell('J' + totalRow)
          .style({fontSize: 9.5, fontFamily: font, underline: true, horizontalAlignment: 'right'})
          .formula('SUM(J11:J' + (row + i) + ')')

        let averageRow = totalRow + 1
        workbook.sheet(sheetName)
          .cell('C' + averageRow)
          .style({fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'left'})
          .value('Average')
        workbook.sheet(sheetName)
          .cell('F' + averageRow)
          .style({fontSize: 9.5, fontFamily: font, underline: true, horizontalAlignment: 'right'})
          .formula('F' + totalRow + '/' + i)
        workbook.sheet(sheetName)
          .cell('G' + averageRow)
          .style({fontSize: 9.5, fontFamily: font, underline: true, horizontalAlignment: 'right'})
          .formula('G' + totalRow + '/' + i)
        workbook.sheet(sheetName)
          .cell('H' + averageRow)
          .style({fontSize: 9.5, fontFamily: font, underline: true, horizontalAlignment: 'right'})
          .formula('H' + totalRow + '/' + i)
        workbook.sheet(sheetName)
          .cell('I' + averageRow)
          .style({fontSize: 9.5, fontFamily: font, underline: true, horizontalAlignment: 'right'})
          .formula('I' + totalRow + '/' + i)
        workbook.sheet(sheetName)
          .cell('J' + averageRow)
          .style({fontSize: 9.5, fontFamily: font, underline: true, horizontalAlignment: 'right'})
          .formula('J' + totalRow + '/' + i)

        let priorYearRow = averageRow + 1
        workbook.sheet(sheetName)
          .cell('C' + priorYearRow)
          .style({fontSize: 9, fontFamily: font, horizontalAlignment: 'left'})
          .value('Prior Year')
        workbook.sheet(sheetName)
          .cell('F' + priorYearRow)
          .style({fontSize: 9.5, fontFamily: font, horizontalAlignment: 'right'})
          .value('0')
        workbook.sheet(sheetName)
          .cell('G' + priorYearRow)
          .style({fontSize: 9.5, fontFamily: font, horizontalAlignment: 'right'})
          .value('0')
        workbook.sheet(sheetName)
          .cell('H' + priorYearRow)
          .style({fontSize: 9.5, fontFamily: font, horizontalAlignment: 'right'})
          .value('0')
        workbook.sheet(sheetName)
          .cell('I' + priorYearRow)
          .style({fontSize: 9.5, fontFamily: font, horizontalAlignment: 'right'})
          .value('0')
        workbook.sheet(sheetName)
          .cell('J' + priorYearRow)
          .style({fontSize: 9.5, fontFamily: font, horizontalAlignment: 'right'})
          .value('0')

        let percentChangeRow = priorYearRow + 1
        workbook.sheet(sheetName)
          .cell('C' + percentChangeRow)
          .style({fontSize: 9, fontFamily: font, horizontalAlignment: 'left'})
          .value('% Change')
        workbook.sheet(sheetName)
          .cell('F' + percentChangeRow)
          .style({fontSize: 9.5, fontFamily: font, horizontalAlignment: 'right'})
          .formula('F' + totalRow + '/F' + priorYearRow)
        workbook.sheet(sheetName)
          .cell('G' + percentChangeRow)
          .style({fontSize: 9.5, fontFamily: font, horizontalAlignment: 'right'})
          .formula('G' + totalRow + '/G' + priorYearRow)
        workbook.sheet(sheetName)
          .cell('H' + percentChangeRow)
          .style({fontSize: 9.5, fontFamily: font, horizontalAlignment: 'right'})
          .formula('H' + totalRow + '/H' + priorYearRow)
        workbook.sheet(sheetName)
          .cell('I' + percentChangeRow)
          .style({fontSize: 9.5, fontFamily: font, horizontalAlignment: 'right'})
          .formula('I' + totalRow + '/I' + priorYearRow)
        workbook.sheet(sheetName)
          .cell('J' + percentChangeRow)
          .style({fontSize: 9.5, fontFamily: font, horizontalAlignment: 'right'})
          .formula('J' + totalRow + '/J' + priorYearRow)

        let noteStartRow = percentChangeRow + 2
        let noteEndRow = noteStartRow + 1
        workbook.sheet(sheetName)
          .cell('C' + noteStartRow)
          .style({fontSize: 9, fontFamily: font, verticalAlignment: 'center', horizontalAlignment: 'center'})
          .value('Note: Entry and Exit numbers in this report refer to Entry and Exit into the Geo-Fence, exclusively, and not the Assignment Area.\nSee definitions in the NELA.')
        workbook.sheet(sheetName).range('C' + noteStartRow + ':J' + noteEndRow).merged(true)

        self.save(workbook, '03')
      })
    },
    renderReport4 () {
      let self = this
      self.initTripDetails()

      let font = self.font
      XlsxPopulate.fromBlankAsync().then(workbook => {
        let sheetName = 'Trip Detail'
        workbook.addSheet(sheetName)
        workbook.sheet(sheetName)
          .cell('A1')
          .style({fontSize: 21.5, fontFamily: font, bold: true, italic: true, verticalAlignment: 'center', horizontalAlignment: 'center'})
          .value('OPOLI')
        workbook.sheet(sheetName).range('A1:C1').merged(true)

        workbook.sheet(sheetName)
          .cell('K1')
          .style({fontSize: 10, fontFamily: font, bold: true, verticalAlignment: 'center'})
          .value('Date Range:')

        let from = moment(self.from)
        let to = moment(self.to)
        let dateRangeText = from.format('MM/DD/YYYY') + ' 00:00:01 to ' + to.format('MM/DD/YYYY') + ' 23:59:59'
        workbook.sheet(sheetName)
          .cell('L1')
          .style({fontSize: 9, fontFamily: font, verticalAlignment: 'center'})
          .value(dateRangeText)
        workbook.sheet(sheetName).range('L1:N1').merged(true)

        workbook.sheet(sheetName)
          .cell('B2')
          .style({fontSize: 21.5, bold: true, fontFamily: font, verticalAlignment: 'center'})
          .value('04 Trip Detail')
        workbook.sheet(sheetName).range('B2:D2').merged(true)

        workbook.sheet(sheetName)
          .cell('A4')
          .style({fontSize: 9, fontFamily: font, italic: true, verticalAlignment: 'center', horizontalAlignment: 'center'})
          .value('The reporting party acknowledges that no information contained in this report is considered to be a trade secret or any other type of\nproprietary interest of the reporting party.  The reporting party acknowledges that the contents of this report may and can be used by LAWA\nfor any purpose including, but not limited to, traffic analysis, transportation planning, and reports to government entities.')
        workbook.sheet(sheetName).range('A4:M7').merged(true)

        // column width adjustments
        let columnWidth = 25
        workbook.sheet(sheetName).column('F').width(columnWidth)
        workbook.sheet(sheetName).column('I').width(columnWidth)
        workbook.sheet(sheetName).column('K').width(columnWidth)
        workbook.sheet(sheetName).column('N').width(columnWidth)

        workbook.sheet(sheetName)
          .cell('A9')
          .style({fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'center', border: 'top', borderStyle: 'medium', borderColor: 'black'})
          .value('Date')

        workbook.sheet(sheetName)
          .cell('B9')
          .style({fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'center', border: 'top', borderStyle: 'medium', borderColor: 'black'})
          .value('Driver ID')

        workbook.sheet(sheetName)
          .cell('C9')
          .style({fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'center', border: 'top', borderStyle: 'medium', borderColor: 'black'})
          .value('Trip ID')

        workbook.sheet(sheetName)
          .cell('D9')
          .style({fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'center', border: 'top', borderStyle: 'medium', borderColor: 'black'})
          .value('Lic. Plate')

        workbook.sheet(sheetName)
          .cell('E9')
          .style({fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'center', border: 'top', borderStyle: 'medium', borderColor: 'black'})
          .value('Rider #')

        /*
        workbook.sheet(sheetName)
          .cell('E9')
          .style({fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'center', border: 'top', borderStyle: 'medium', borderColor: 'black'})
          .value('Reservation')
        */

        workbook.sheet(sheetName)
          .cell('F9')
          .style({fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'center', border: 'top', borderStyle: 'medium', borderColor: 'black'})
          .value('Assignment Time')

        workbook.sheet(sheetName)
          .cell('G9')
          .style({fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'center', border: 'top', borderStyle: 'medium', borderColor: 'black'})
          .value('Lat')

        workbook.sheet(sheetName)
          .cell('H9')
          .style({fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'center', border: 'top', borderStyle: 'medium', borderColor: 'black'})
          .value('Lon')

        workbook.sheet(sheetName)
          .cell('I9')
          .style({fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'center', border: 'top', borderStyle: 'medium', borderColor: 'black'})
          .value('Entry Time')

        workbook.sheet(sheetName)
          .cell('J9')
          .style({fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'center', border: 'top', borderStyle: 'medium', borderColor: 'black'})
          .value('Txn Type')

        workbook.sheet(sheetName)
          .cell('K9')
          .style({fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'center', border: 'top', borderStyle: 'medium', borderColor: 'black'})
          .value('Txn Time')

        workbook.sheet(sheetName)
          .cell('L9')
          .style({fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'center', border: 'top', borderStyle: 'medium', borderColor: 'black'})
          .value('Lat')

        workbook.sheet(sheetName)
          .cell('M9')
          .style({fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'center', border: 'top', borderStyle: 'medium', borderColor: 'black'})
          .value('Lon')

        workbook.sheet(sheetName)
          .cell('N9')
          .style({fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'center', border: 'top', borderStyle: 'medium', borderColor: 'black'})
          .value('Exit Time')

        let row = 10
        let i = 0
        let pickupCount = 0
        let dropoffCount = 0
        let rowNumber = row + i
        for (i = 0; i < self.report.tripDetails.length; i++) {
          let item = self.report.tripDetails[i]
          
          rowNumber = row + i
          workbook.sheet(sheetName)
            .cell('A' + rowNumber)
            .style({fontSize: 9, fontFamily: font, horizontalAlignment: 'center', border: 'top', borderStyle: 'thin', borderColor: 'black'})
            .value(item.txnTime.substring(0,10))

          workbook.sheet(sheetName)
            .cell('B' + rowNumber)
            .style({fontSize: 9, fontFamily: font, horizontalAlignment: 'center', border: 'top', borderStyle: 'thin', borderColor: 'black'})
            .value(item.driverId)

          let tripId = item.driverId + ':' + item.rsvpId
          workbook.sheet(sheetName)
            .cell('C' + rowNumber)
            .style({fontSize: 9, fontFamily: font, horizontalAlignment: 'center', border: 'top', borderStyle: 'thin', borderColor: 'black'})
            .value(tripId)

          workbook.sheet(sheetName)
            .cell('D' + rowNumber)
            .style({fontSize: 9, fontFamily: font, horizontalAlignment: 'center', border: 'top', borderStyle: 'thin', borderColor: 'black'})
            .value(item.licensePlate)

          workbook.sheet(sheetName)
            .cell('E' + rowNumber)
            .style({fontSize: 9, fontFamily: font, horizontalAlignment: 'center', border: 'top', borderStyle: 'thin', borderColor: 'black'})
            .value(item.pickupOrder)

          /*
          workbook.sheet(sheetName)
            .cell('E' + rowNumber)
            .style({fontSize: 9, fontFamily: font, horizontalAlignment: 'center', border: 'top', borderStyle: 'thin', borderColor: 'black'})
            .value(item.reservation)
          */

          workbook.sheet(sheetName)
            .cell('F' + rowNumber)
            .style({fontSize: 9, fontFamily: font, horizontalAlignment: 'center', border: 'top', borderStyle: 'thin', borderColor: 'black'})
            .value(item.assignmentTime)

          workbook.sheet(sheetName)
            .cell('G' + rowNumber)
            .style({fontSize: 9, fontFamily: font, horizontalAlignment: 'center', border: 'top', borderStyle: 'thin', borderColor: 'black'})
            .value(item.entryLat)

          workbook.sheet(sheetName)
            .cell('H' + rowNumber)
            .style({fontSize: 9, fontFamily: font, horizontalAlignment: 'center', border: 'top', borderStyle: 'thin', borderColor: 'black'})
            .value(item.entryLon)

          workbook.sheet(sheetName)
            .cell('I' + rowNumber)
            .style({fontSize: 9, fontFamily: font, horizontalAlignment: 'center', border: 'top', borderStyle: 'thin', borderColor: 'black'})
            .value(item.entryTime)

          workbook.sheet(sheetName)
            .cell('J' + rowNumber)
            .style({fontSize: 9, fontFamily: font, horizontalAlignment: 'center', border: 'top', borderStyle: 'thin', borderColor: 'black'})
            .value(item.txnType)

          workbook.sheet(sheetName)
            .cell('K' + rowNumber)
            .style({fontSize: 9, fontFamily: font, horizontalAlignment: 'center', border: 'top', borderStyle: 'thin', borderColor: 'black'})
            .value(item.txnTime)

          workbook.sheet(sheetName)
            .cell('L' + rowNumber)
            .style({fontSize: 9, fontFamily: font, horizontalAlignment: 'center', border: 'top', borderStyle: 'thin', borderColor: 'black'})
            .value(item.exitLat)

          workbook.sheet(sheetName)
            .cell('M' + rowNumber)
            .style({fontSize: 9, fontFamily: font, horizontalAlignment: 'center', border: 'top', borderStyle: 'thin', borderColor: 'black'})
            .value(item.exitLon)

          workbook.sheet(sheetName)
            .cell('N' + rowNumber)
            .style({fontSize: 9, fontFamily: font, horizontalAlignment: 'center', border: 'top', borderStyle: 'thin', borderColor: 'black'})
            .value(item.exitTime)

          if (item.txnType === 'Pick-Up') {
            pickupCount++
          } else if (item.txnType === 'Drop-Off') {
            dropoffCount++
          }
        }

        rowNumber = rowNumber + 2
        /*
        workbook.sheet(sheetName)
          .cell('L' + rowNumber)
          .style({fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'center'})
          .value('Account Summary')
        workbook.sheet(sheetName).range('K' + rowNumber + ':M' + rowNumber).merged(true)
        */

        rowNumber = rowNumber + 1
        workbook.sheet(sheetName)
          .cell('L' + rowNumber)
          .style({fontSize: 9, fontFamily: font, horizontalAlignment: 'center'})
          .value('Pick-Up Count')
        workbook.sheet(sheetName)
          .cell('M' + rowNumber)
          .style({fontSize: 9, fontFamily: font, horizontalAlignment: 'center'})
          .value('Drop-Off Count')
        workbook.sheet(sheetName)
          .cell('N' + rowNumber)
          .style({fontSize: 9, fontFamily: font, horizontalAlignment: 'center'})
          .value('Total Counts')

        rowNumber = rowNumber + 1
        workbook.sheet(sheetName)
          .cell('L' + rowNumber)
          .style({fontSize: 9, fontFamily: font, horizontalAlignment: 'center'})
          .value(pickupCount)
        workbook.sheet(sheetName)
          .cell('M' + rowNumber)
          .style({fontSize: 9, fontFamily: font, horizontalAlignment: 'center'})
          .value(dropoffCount)
        workbook.sheet(sheetName)
          .cell('N' + rowNumber)
          .style({fontSize: 9, fontFamily: font, horizontalAlignment: 'center'})
          .value(pickupCount + dropoffCount)

        rowNumber = rowNumber + 2
        workbook.sheet(sheetName).range('A' + rowNumber + ':N' + rowNumber).merged(true)
        workbook.sheet(sheetName)
          .cell('A' + rowNumber)
          .style({fontSize: 9, fontFamily: font, verticalAlignment: 'center', horizontalAlignment: 'center'})
          .value('Note: Entry and Exit numbers in this report refer to Entry and Exit into the Geo-Fence, exclusively, and not the Assignment Area. See definitions in the NELA.')

        self.save(workbook, '04')
      })
    },
    renderReport5 () {
      let self = this
      self.initAssignmentPickupTrip()

      let font = self.font
      XlsxPopulate.fromBlankAsync().then(workbook => {
        let sheetName = 'Assignment - Pick-Up Trip'
        workbook.addSheet(sheetName)
        workbook.sheet(sheetName)
          .cell('A1')
          .style({fontSize: 21.5, fontFamily: font, bold: true, italic: true, verticalAlignment: 'center', horizontalAlignment: 'center'})
          .value('OPOLI')
        workbook.sheet(sheetName).range('A1:C1').merged(true)

        workbook.sheet(sheetName)
          .cell('H1')
          .style({fontSize: 10, fontFamily: font, bold: true, verticalAlignment: 'center'})
          .value('Date Range:')

        let from = moment(self.from)
        let to = moment(self.to)
        let dateRangeText = from.format('MM/DD/YYYY') + ' 00:00:01 to ' + to.format('MM/DD/YYYY') + ' 23:59:59'
        workbook.sheet(sheetName)
          .cell('I1')
          .style({fontSize: 9, fontFamily: font, verticalAlignment: 'center'})
          .value(dateRangeText)
        workbook.sheet(sheetName).range('I1:K1').merged(true)

        workbook.sheet(sheetName)
          .cell('B2')
          .style({fontSize: 21.5, bold: true, fontFamily: font, verticalAlignment: 'center'})
          .value('05 Assignment/Pick-Up Trip')
        workbook.sheet(sheetName).range('B2:E2').merged(true)

        workbook.sheet(sheetName)
          .cell('A4')
          .style({fontSize: 9, fontFamily: font, italic: true, verticalAlignment: 'center', horizontalAlignment: 'center'})
          .value('The reporting party acknowledges that no information contained in this report is considered to be a trade secret or any other type of\nproprietary interest of the reporting party.  The reporting party acknowledges that the contents of this report may and can be used by LAWA\nfor any purpose including, but not limited to, traffic analysis, transportation planning, and reports to government entities.')
        workbook.sheet(sheetName).range('A4:K7').merged(true)

        // column width adjustments
        let columnWidth = 25
        workbook.sheet(sheetName).column('D').width(columnWidth)
        workbook.sheet(sheetName).column('G').width(columnWidth)
        workbook.sheet(sheetName).column('H').width(columnWidth)
        workbook.sheet(sheetName).column('K').width(columnWidth)

        workbook.sheet(sheetName)
          .cell('A9')
          .style({fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'center', border: 'top', borderStyle: 'medium', borderColor: 'black'})
          .value('Date')

        workbook.sheet(sheetName)
          .cell('B9')
          .style({fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'center', border: 'top', borderStyle: 'medium', borderColor: 'black'})
          .value('Driver ID')

        workbook.sheet(sheetName)
          .cell('C9')
          .style({fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'center', border: 'top', borderStyle: 'medium', borderColor: 'black'})
          .value('Lic. Plate')

        workbook.sheet(sheetName)
          .cell('D9')
          .style({fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'center', border: 'top', borderStyle: 'medium', borderColor: 'black'})
          .value('Assignment Time')

        workbook.sheet(sheetName)
          .cell('E9')
          .style({fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'center', border: 'top', borderStyle: 'medium', borderColor: 'black'})
          .value('Lat')

        workbook.sheet(sheetName)
          .cell('F9')
          .style({fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'center', border: 'top', borderStyle: 'medium', borderColor: 'black'})
          .value('Lon')

        workbook.sheet(sheetName)
          .cell('G9')
          .style({fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'center', border: 'top', borderStyle: 'medium', borderColor: 'black'})
          .value('Entry Time')

        workbook.sheet(sheetName)
          .cell('H9')
          .style({fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'center', border: 'top', borderStyle: 'medium', borderColor: 'black'})
          .value('Pick-Up Time')

        workbook.sheet(sheetName)
          .cell('I9')
          .style({fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'center', border: 'top', borderStyle: 'medium', borderColor: 'black'})
          .value('Lat')

        workbook.sheet(sheetName)
          .cell('J9')
          .style({fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'center', border: 'top', borderStyle: 'medium', borderColor: 'black'})
          .value('Lon')

        workbook.sheet(sheetName)
          .cell('K9')
          .style({fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'center', border: 'top', borderStyle: 'medium', borderColor: 'black'})
          .value('Exit Time')

        let row = 10
        let i = 0
        let pickupCount = 0
        let dropoffCount = 0
        let rowNumber = row + i
        for (i = 0; i < self.report.assignmentPickupTrip.length; i++) {
          let item = self.report.assignmentPickupTrip[i]
          
          rowNumber = row + i
          workbook.sheet(sheetName)
            .cell('A' + rowNumber)
            .style({fontSize: 9, fontFamily: font, horizontalAlignment: 'center', border: 'top', borderStyle: 'thin', borderColor: 'black'})
            .value(item.date)

          workbook.sheet(sheetName)
            .cell('B' + rowNumber)
            .style({fontSize: 9, fontFamily: font, horizontalAlignment: 'center', border: 'top', borderStyle: 'thin', borderColor: 'black'})
            .value(item.driverId)

          workbook.sheet(sheetName)
            .cell('C' + rowNumber)
            .style({fontSize: 9, fontFamily: font, horizontalAlignment: 'center', border: 'top', borderStyle: 'thin', borderColor: 'black'})
            .value(item.licensePlate)

          workbook.sheet(sheetName)
            .cell('D' + rowNumber)
            .style({fontSize: 9, fontFamily: font, horizontalAlignment: 'center', border: 'top', borderStyle: 'thin', borderColor: 'black'})
            .value(item.assignmentTime)

          workbook.sheet(sheetName)
            .cell('E' + rowNumber)
            .style({fontSize: 9, fontFamily: font, horizontalAlignment: 'center', border: 'top', borderStyle: 'thin', borderColor: 'black'})
            .value(item.entryLat)

          workbook.sheet(sheetName)
            .cell('F' + rowNumber)
            .style({fontSize: 9, fontFamily: font, horizontalAlignment: 'center', border: 'top', borderStyle: 'thin', borderColor: 'black'})
            .value(item.entryLon)

          workbook.sheet(sheetName)
            .cell('G' + rowNumber)
            .style({fontSize: 9, fontFamily: font, horizontalAlignment: 'center', border: 'top', borderStyle: 'thin', borderColor: 'black'})
            .value(item.entryTime)

          workbook.sheet(sheetName)
            .cell('H' + rowNumber)
            .style({fontSize: 9, fontFamily: font, horizontalAlignment: 'center', border: 'top', borderStyle: 'thin', borderColor: 'black'})
            .value(item.pickupTime)

          workbook.sheet(sheetName)
            .cell('I' + rowNumber)
            .style({fontSize: 9, fontFamily: font, horizontalAlignment: 'center', border: 'top', borderStyle: 'thin', borderColor: 'black'})
            .value(item.exitLat)

          workbook.sheet(sheetName)
            .cell('J' + rowNumber)
            .style({fontSize: 9, fontFamily: font, horizontalAlignment: 'center', border: 'top', borderStyle: 'thin', borderColor: 'black'})
            .value(item.exitLon)

          workbook.sheet(sheetName)
            .cell('K' + rowNumber)
            .style({fontSize: 9, fontFamily: font, horizontalAlignment: 'center', border: 'top', borderStyle: 'thin', borderColor: 'black'})
            .value(item.exitTime)

          if (item.txnType === 'Pick-Up') {
            pickupCount++
          } else if (item.txnType === 'Drop-Off') {
            dropoffCount++
          }
        }

        rowNumber = rowNumber + 2
        workbook.sheet(sheetName)
          .cell('I' + rowNumber)
          .style({fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'center'})
          .value('Account Summary')
        workbook.sheet(sheetName).range('I' + rowNumber + ':K' + rowNumber).merged(true)

        rowNumber = rowNumber + 1
        workbook.sheet(sheetName)
          .cell('I' + rowNumber)
          .style({fontSize: 9, fontFamily: font, horizontalAlignment: 'center'})
          .value('Pick-Up Count')
        workbook.sheet(sheetName)
          .cell('J' + rowNumber)
          .style({fontSize: 9, fontFamily: font, horizontalAlignment: 'center'})
          .value('Drop-Off Count')
        workbook.sheet(sheetName)
          .cell('K' + rowNumber)
          .style({fontSize: 9, fontFamily: font, horizontalAlignment: 'center'})
          .value('Total Counts')

        rowNumber = rowNumber + 1
        workbook.sheet(sheetName)
          .cell('I' + rowNumber)
          .style({fontSize: 9, fontFamily: font, horizontalAlignment: 'center'})
          .value(pickupCount)
        workbook.sheet(sheetName)
          .cell('J' + rowNumber)
          .style({fontSize: 9, fontFamily: font, horizontalAlignment: 'center'})
          .value(dropoffCount)
        workbook.sheet(sheetName)
          .cell('K' + rowNumber)
          .style({fontSize: 9, fontFamily: font, horizontalAlignment: 'center'})
          .value(pickupCount + dropoffCount)

        rowNumber = rowNumber + 2
        workbook.sheet(sheetName)
          .cell('A' + rowNumber)
          .style({fontSize: 9, fontFamily: font, verticalAlignment: 'center', horizontalAlignment: 'center'})
          .value('Note: Entry and Exit numbers in this report refer to Entry and Exit into the Geo-Fence, exclusively, and not the Assignment Area. See definitions in the NELA.')
        workbook.sheet(sheetName).range('A' + rowNumber + ':K' + rowNumber).merged(true)

        self.save(workbook, '05')
      })
    },
    renderReport6 () {
      let self = this
      self.initActivaAccounts()

      let font = self.font
      XlsxPopulate.fromBlankAsync().then(workbook => {
        let sheetName = 'Active Accounts'
        workbook.addSheet(sheetName)
        workbook.sheet(sheetName)
          .cell('A1')
          .style({fontSize: 21.5, fontFamily: font, bold: true, italic: true, verticalAlignment: 'center', horizontalAlignment: 'center'})
          .value('OPOLI')
        workbook.sheet(sheetName).range('A1:C1').merged(true)

        workbook.sheet(sheetName)
          .cell('I1')
          .style({fontSize: 10, fontFamily: font, bold: true, verticalAlignment: 'center'})
          .value('Date')

        let from = moment(self.from)
        workbook.sheet(sheetName)
          .cell('J1')
          .style({fontSize: 9, fontFamily: font, verticalAlignment: 'center'})
          .value(from.format('MM/DD/YYYY'))
        workbook.sheet(sheetName).range('J1:K1').merged(true)

        workbook.sheet(sheetName)
          .cell('C2')
          .style({fontSize: 21.5, bold: true, fontFamily: font, verticalAlignment: 'center'})
          .value('06 Active Accounts')
        workbook.sheet(sheetName).range('C2:F2').merged(true)

        workbook.sheet(sheetName)
          .cell('A4')
          .style({fontSize: 9, fontFamily: font, italic: true, verticalAlignment: 'center', horizontalAlignment: 'center'})
          .value('The reporting party acknowledges that no information contained in this report is considered to be a trade secret or any other type of\nproprietary interest of the reporting party.  The reporting party acknowledges that the contents of this report may and can be used by LAWA\nfor any purpose including, but not limited to, traffic analysis, transportation planning, and reports to government entities.')
        workbook.sheet(sheetName).range('A4:K7').merged(true)

        workbook.sheet(sheetName)
          .cell('D9')
          .style({fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'center', verticalAlignment: 'center', border: 'top', borderStyle: 'medium', borderColor: 'black'})
          .value('Placard ID')

        workbook.sheet(sheetName)
          .cell('E9')
          .style({fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'center', verticalAlignment: 'center', border: 'top', borderStyle: 'medium', borderColor: 'black'})
          .value('Driver ID')

        workbook.sheet(sheetName)
          .cell('F9')
          .style({fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'center', verticalAlignment: 'center', border: 'top', borderStyle: 'medium', borderColor: 'black'})
          .value('License Plate')

        workbook.sheet(sheetName)
          .cell('G9')
          .style({fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'center', verticalAlignment: 'center', border: 'top', borderStyle: 'medium', borderColor: 'black'})
          .value('VIN')
        workbook.sheet(sheetName).range('G9:H9').merged(true)

        workbook.sheet(sheetName)
          .cell('I9')
          .style({fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'center', verticalAlignment: 'center', border: 'top', borderStyle: 'medium', borderColor: 'black'})
          .value('Placard\nIssue Date')

        let row = 10
        let i = 0
        let rowNumber = row + i
        for (i = 0; i < self.report.activeAccounts.length; i++) {
          let item = self.report.activeAccounts[i]
          rowNumber = row + i
          workbook.sheet(sheetName)
            .cell('D' + rowNumber)
            .style({fontSize: 9, fontFamily: font, horizontalAlignment: 'center', border: 'top', borderStyle: 'thin', borderColor: 'black'})
            .value(item.placardId)
          workbook.sheet(sheetName)
            .cell('E' + rowNumber)
            .style({fontSize: 9, fontFamily: font, horizontalAlignment: 'center', border: 'top', borderStyle: 'thin', borderColor: 'black'})
            .value(item.driverId)
          workbook.sheet(sheetName)
            .cell('F' + rowNumber)
            .style({fontSize: 9, fontFamily: font, horizontalAlignment: 'center', border: 'top', borderStyle: 'thin', borderColor: 'black'})
            .value(item.licensePlate)
          workbook.sheet(sheetName)
            .cell('G' + rowNumber)
            .style({fontSize: 9, fontFamily: font, horizontalAlignment: 'center', border: 'top', borderStyle: 'thin', borderColor: 'black'})
            .value(item.vin)
          workbook.sheet(sheetName).range('G' + rowNumber + ':H' + rowNumber).merged(true)
          workbook.sheet(sheetName)
            .cell('I' + rowNumber)
            .style({fontSize: 9, fontFamily: font, horizontalAlignment: 'center', border: 'top', borderStyle: 'thin', borderColor: 'black'})
            .value(item.placardIssueDate)
        }

        rowNumber = rowNumber + 2
        workbook.sheet(sheetName)
          .cell('D' + rowNumber)
          .style({fontSize: 9, fontFamily: font, horizontalAlignment: 'left'})
          .value('Grand Total Active Airport Placards: ' + self.report.activeAccounts.length)
        workbook.sheet(sheetName).range('D' + rowNumber + ':I' + rowNumber).merged(true)

        rowNumber = rowNumber + 1
        workbook.sheet(sheetName)
          .cell('D' + rowNumber)
          .style({fontSize: 9, fontFamily: font, horizontalAlignment: 'left'})
          .value('Grand Total Active Drivers: ' + self.report.activeAccounts.length)
        workbook.sheet(sheetName).range('D' + rowNumber + ':I' + rowNumber).merged(true)

        rowNumber = rowNumber + 1
        workbook.sheet(sheetName)
          .cell('D' + rowNumber)
          .style({fontSize: 9, fontFamily: font, horizontalAlignment: 'left'})
          .value('Grand Total Active Vehicles: ' + self.report.activeAccounts.length)
        workbook.sheet(sheetName).range('D' + rowNumber + ':I' + rowNumber).merged(true)

        rowNumber = rowNumber + 2
        workbook.sheet(sheetName)
          .cell('A' + rowNumber)
          .style({fontSize: 9, fontFamily: font, verticalAlignment: 'center', horizontalAlignment: 'center'})
          .value('Note: Entry and Exit numbers in this report refer to Entry and Exit into the Geo-Fence, exclusively, and not the Assignment Area. See definitions in the NELA.')
        workbook.sheet(sheetName).range('A' + rowNumber + ':K' + rowNumber).merged(true)

        self.save(workbook, '06')
      })
    },
    renderReport7 () {
      let self = this
      self.initAssignmentAreaDetails()

      let font = self.font
      XlsxPopulate.fromBlankAsync().then(workbook => {
        let sheetName = 'Assignment Area Details'
        workbook.addSheet(sheetName)
        workbook.sheet(sheetName)
          .cell('A1')
          .style({fontSize: 21.5, fontFamily: font, bold: true, italic: true, verticalAlignment: 'center', horizontalAlignment: 'center'})
          .value('OPOLI')
        workbook.sheet(sheetName).range('A1:C1').merged(true)

        workbook.sheet(sheetName)
          .cell('I1')
          .style({fontSize: 10, fontFamily: font, bold: true, verticalAlignment: 'center'})
          .value('Date Range:')

        let from = moment(self.from)
        let to = moment(self.to)
        let dateRangeText = from.format('MM/DD/YYYY') + ' 00:00:01 to ' + to.format('MM/DD/YYYY') + ' 23:59:59'
        workbook.sheet(sheetName)
          .cell('J1')
          .style({fontSize: 9, fontFamily: font, verticalAlignment: 'center'})
          .value(dateRangeText)
        workbook.sheet(sheetName).range('J1:L1').merged(true)

        workbook.sheet(sheetName)
          .cell('B2')
          .style({fontSize: 21.5, bold: true, fontFamily: font, verticalAlignment: 'center'})
          .value('07 Assignment Area Details')
        workbook.sheet(sheetName).range('B2:E2').merged(true)

        workbook.sheet(sheetName)
          .cell('A4')
          .style({fontSize: 9, fontFamily: font, italic: true, verticalAlignment: 'center', horizontalAlignment: 'center'})
          .value('The reporting party acknowledges that no information contained in this report is considered to be a trade secret or any other type of\nproprietary interest of the reporting party.  The reporting party acknowledges that the contents of this report may and can be used by LAWA\nfor any purpose including, but not limited to, traffic analysis, transportation planning, and reports to government entities.')
        workbook.sheet(sheetName).range('A4:K7').merged(true)

        // column width adjustments
        let columnWidth = 25
        workbook.sheet(sheetName).column('D').width(columnWidth)
        workbook.sheet(sheetName).column('G').width(columnWidth)
        workbook.sheet(sheetName).column('J').width(columnWidth)

        workbook.sheet(sheetName)
          .cell('A9')
          .style({fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'center', border: 'top', borderStyle: 'medium', borderColor: 'black'})
          .value('Date')

        workbook.sheet(sheetName)
          .cell('B9')
          .style({fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'center', border: 'top', borderStyle: 'medium', borderColor: 'black'})
          .value('Driver ID')

        workbook.sheet(sheetName)
          .cell('C9')
          .style({fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'center', border: 'top', borderStyle: 'medium', borderColor: 'black'})
          .value('Lic. Plate')

        workbook.sheet(sheetName)
          .cell('D9')
          .style({fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'center', border: 'top', borderStyle: 'medium', borderColor: 'black'})
          .value('Entry Time')

        workbook.sheet(sheetName)
          .cell('E9')
          .style({fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'center', border: 'top', borderStyle: 'medium', borderColor: 'black'})
          .value('Lat')

        workbook.sheet(sheetName)
          .cell('F9')
          .style({fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'center', border: 'top', borderStyle: 'medium', borderColor: 'black'})
          .value('Lon')

        workbook.sheet(sheetName)
          .cell('G9')
          .style({fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'center', border: 'top', borderStyle: 'medium', borderColor: 'black'})
          .value('Assignment Time')

        workbook.sheet(sheetName)
          .cell('H9')
          .style({fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'center', border: 'top', borderStyle: 'medium', borderColor: 'black'})
          .value('Lat')

        workbook.sheet(sheetName)
          .cell('I9')
          .style({fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'center', border: 'top', borderStyle: 'medium', borderColor: 'black'})
          .value('Lon')

        workbook.sheet(sheetName)
          .cell('J9')
          .style({fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'center', border: 'top', borderStyle: 'medium', borderColor: 'black'})
          .value('Exit Time')

        workbook.sheet(sheetName)
          .cell('K9')
          .style({fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'center', border: 'top', borderStyle: 'medium', borderColor: 'black'})
          .value('Lat')

        workbook.sheet(sheetName)
          .cell('L9')
          .style({fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'center', border: 'top', borderStyle: 'medium', borderColor: 'black'})
          .value('Lon')

        let row = 10
        let i = 0
        let rowNumber = row + i
        for (i = 0; i < self.report.assignmentAreaDetails.length; i++) {
          let item = self.report.assignmentAreaDetails[i]
          
          rowNumber = row + i
          workbook.sheet(sheetName)
            .cell('A' + rowNumber)
            .style({fontSize: 9, fontFamily: font, horizontalAlignment: 'center', border: 'top', borderStyle: 'thin', borderColor: 'black'})
            .value(item.date)

          workbook.sheet(sheetName)
            .cell('B' + rowNumber)
            .style({fontSize: 9, fontFamily: font, horizontalAlignment: 'center', border: 'top', borderStyle: 'thin', borderColor: 'black'})
            .value(item.driverId)

          workbook.sheet(sheetName)
            .cell('C' + rowNumber)
            .style({fontSize: 9, fontFamily: font, horizontalAlignment: 'center', border: 'top', borderStyle: 'thin', borderColor: 'black'})
            .value(item.licensePlate)

          workbook.sheet(sheetName)
            .cell('D' + rowNumber)
            .style({fontSize: 9, fontFamily: font, horizontalAlignment: 'center', border: 'top', borderStyle: 'thin', borderColor: 'black'})
            .value(item.entryTime)

          workbook.sheet(sheetName)
            .cell('E' + rowNumber)
            .style({fontSize: 9, fontFamily: font, horizontalAlignment: 'center', border: 'top', borderStyle: 'thin', borderColor: 'black'})
            .value(item.entryLat)

          workbook.sheet(sheetName)
            .cell('F' + rowNumber)
            .style({fontSize: 9, fontFamily: font, horizontalAlignment: 'center', border: 'top', borderStyle: 'thin', borderColor: 'black'})
            .value(item.entryLon)

          workbook.sheet(sheetName)
            .cell('G' + rowNumber)
            .style({fontSize: 9, fontFamily: font, horizontalAlignment: 'center', border: 'top', borderStyle: 'thin', borderColor: 'black'})
            .value(item.assignmentTime)

          workbook.sheet(sheetName)
            .cell('H' + rowNumber)
            .style({fontSize: 9, fontFamily: font, horizontalAlignment: 'center', border: 'top', borderStyle: 'thin', borderColor: 'black'})
            .value(item.assignmentLat)

          workbook.sheet(sheetName)
            .cell('I' + rowNumber)
            .style({fontSize: 9, fontFamily: font, horizontalAlignment: 'center', border: 'top', borderStyle: 'thin', borderColor: 'black'})
            .value(item.assignmentLon)

          workbook.sheet(sheetName)
            .cell('J' + rowNumber)
            .style({fontSize: 9, fontFamily: font, horizontalAlignment: 'center', border: 'top', borderStyle: 'thin', borderColor: 'black'})
            .value(item.exitTime)

          workbook.sheet(sheetName)
            .cell('K' + rowNumber)
            .style({fontSize: 9, fontFamily: font, horizontalAlignment: 'center', border: 'top', borderStyle: 'thin', borderColor: 'black'})
            .value(item.exitLat)

          workbook.sheet(sheetName)
            .cell('L' + rowNumber)
            .style({fontSize: 9, fontFamily: font, horizontalAlignment: 'center', border: 'top', borderStyle: 'thin', borderColor: 'black'})
            .value(item.exitLon)
        }

        rowNumber = rowNumber + 2
        workbook.sheet(sheetName)
          .cell('H' + rowNumber)
          .style({fontSize: 9, fontFamily: font, underline: true, horizontalAlignment: 'center'})
          .value('Summary')
        workbook.sheet(sheetName).range('H' + rowNumber + ':J' + rowNumber).merged(true)

        rowNumber = rowNumber + 1
        workbook.sheet(sheetName)
          .cell('H' + rowNumber)
          .style({fontSize: 9, fontFamily: font, horizontalAlignment: 'center', verticalAlignment: 'center'})
          .value('Entry\nCounts')
        workbook.sheet(sheetName)
          .cell('I' + rowNumber)
          .style({fontSize: 9, fontFamily: font, horizontalAlignment: 'center', verticalAlignment: 'center'})
          .value('Assignment\nCounts')
        workbook.sheet(sheetName)
          .cell('J' + rowNumber)
          .style({fontSize: 9, fontFamily: font, horizontalAlignment: 'center', verticalAlignment: 'center'})
          .value('Exit Counts')

        rowNumber = rowNumber + 1
        workbook.sheet(sheetName)
          .cell('H' + rowNumber)
          .style({fontSize: 9, fontFamily: font, horizontalAlignment: 'center', verticalAlignment: 'center'})
          .value(self.report.assignmentAreaDetails.length)
        workbook.sheet(sheetName)
          .cell('I' + rowNumber)
          .style({fontSize: 9, fontFamily: font, horizontalAlignment: 'center', verticalAlignment: 'center'})
          .value(self.report.assignmentAreaDetails.length)
        workbook.sheet(sheetName)
          .cell('J' + rowNumber)
          .style({fontSize: 9, fontFamily: font, horizontalAlignment: 'center', verticalAlignment: 'center'})
          .value(self.report.assignmentAreaDetails.length)

        rowNumber = rowNumber + 2
        workbook.sheet(sheetName)
          .cell('A' + rowNumber)
          .style({fontSize: 9, fontFamily: font, verticalAlignment: 'center', horizontalAlignment: 'center'})
          .value('Note: Entry and Exit numbers in this report refer to Entry and Exit into the Geo-Fence, exclusively, and not the Assignment Area. See definitions in the NELA.')
        workbook.sheet(sheetName).range('A' + rowNumber + ':L' + rowNumber).merged(true)

        self.save(workbook, '07')
      })
    },
    renderReport8 () {
      let self = this
      self.initAssignmentAreaDailyCount()

      let font = self.font
      XlsxPopulate.fromBlankAsync().then(workbook => {
        for (let property in self.report.assignmentAreaDailyCount) {
          if (!self.report.assignmentAreaDailyCount.hasOwnProperty(property)) {
            continue
          }
          let item = self.report.assignmentAreaDailyCount[property]

          let sheetName = property.replace(/\//g, '-')
          workbook.addSheet(sheetName)
          workbook.sheet(sheetName)
            .cell('A1')
            .style({fontSize: 21.5, fontFamily: font, bold: true, italic: true, verticalAlignment: 'center', horizontalAlignment: 'center'})
            .value('OPOLI')
          workbook.sheet(sheetName).range('A1:C1').merged(true)

          workbook.sheet(sheetName)
            .cell('I1')
            .style({fontSize: 10, fontFamily: font, bold: true, verticalAlignment: 'center'})
            .value('Date:')

          workbook.sheet(sheetName)
            .cell('J1')
            .style({fontSize: 9, fontFamily: font, verticalAlignment: 'center'})
            .value(property)

          workbook.sheet(sheetName)
            .cell('B2')
            .style({fontSize: 21.5, bold: true, fontFamily: font, verticalAlignment: 'center'})
            .value('08 Assignment Area Daily Count')
          workbook.sheet(sheetName).range('B2:F2').merged(true)

          workbook.sheet(sheetName)
            .cell('A4')
            .style({fontSize: 9, fontFamily: font, italic: true, verticalAlignment: 'center', horizontalAlignment: 'center'})
            .value('The reporting party acknowledges that no information contained in this report is considered to be a trade secret or any other type of\nproprietary interest of the reporting party.  The reporting party acknowledges that the contents of this report may and can be used by LAWA\nfor any purpose including, but not limited to, traffic analysis, transportation planning, and reports to government entities.')
          workbook.sheet(sheetName).range('A4:M7').merged(true)

          workbook.sheet(sheetName)
            .cell('B9')
            .style({fontSize: 11, fontFamily: font, verticalAlignment: 'center', horizontalAlignment: 'center', border: 'border', borderStyle: 'medium', borderColor: 'black'})
            .value('Time')
          workbook.sheet(sheetName)
            .cell('C9')
            .style({fontSize: 11, fontFamily: font, verticalAlignment: 'center', horizontalAlignment: 'center', border: 'border', borderStyle: 'medium', borderColor: 'black'})
            .value('Vehicle\nCount')

          workbook.sheet(sheetName)
            .cell('E9')
            .style({fontSize: 11, fontFamily: font, verticalAlignment: 'center', horizontalAlignment: 'center', border: 'border', borderStyle: 'medium', borderColor: 'black'})
            .value('Time')
          workbook.sheet(sheetName)
            .cell('F9')
            .style({fontSize: 11, fontFamily: font, verticalAlignment: 'center', horizontalAlignment: 'center', border: 'border', borderStyle: 'medium', borderColor: 'black'})
            .value('Vehicle\nCount')

          workbook.sheet(sheetName)
            .cell('H9')
            .style({fontSize: 11, fontFamily: font, verticalAlignment: 'center', horizontalAlignment: 'center', border: 'border', borderStyle: 'medium', borderColor: 'black'})
            .value('Time')
          workbook.sheet(sheetName)
            .cell('I9')
            .style({fontSize: 11, fontFamily: font, verticalAlignment: 'center', horizontalAlignment: 'center', border: 'border', borderStyle: 'medium', borderColor: 'black'})
            .value('Vehicle\nCount')

          workbook.sheet(sheetName)
            .cell('K9')
            .style({fontSize: 11, fontFamily: font, verticalAlignment: 'center', horizontalAlignment: 'center', border: 'border', borderStyle: 'medium', borderColor: 'black'})
            .value('Time')
          workbook.sheet(sheetName)
            .cell('L9')
            .style({fontSize: 11, fontFamily: font, verticalAlignment: 'center', horizontalAlignment: 'center', border: 'border', borderStyle: 'medium', borderColor: 'black'})
            .value('Vehicle\nCount')

          let row = 10
          let i = 0
          let j = 0
          let rowNumber = row + j
          for (let key in item) {
            if (!item.hasOwnProperty(key)) {
              continue
            }
            let timeColumn = 'B'
            let countColumn = 'C'

            if (i > 23 && i <= 47) {
              timeColumn = 'E'
              countColumn = 'F'
            } else if (i > 47 && i <= 71) {
              timeColumn = 'H'
              countColumn = 'I'
            } else if (i > 71) {
              timeColumn = 'K'
              countColumn = 'L'
            }

            rowNumber = row + j
            let timeCell = timeColumn + rowNumber
            let countCell = countColumn + rowNumber

            workbook.sheet(sheetName)
              .cell(timeCell)
              .style({fontSize: 11, fontFamily: font, verticalAlignment: 'center', horizontalAlignment: 'center', border: 'border', borderStyle: 'medium', borderColor: 'black'})
              .value(key)
            workbook.sheet(sheetName)
              .cell(countCell)
              .style({fontSize: 11, fontFamily: font, verticalAlignment: 'center', horizontalAlignment: 'center', border: 'border', borderStyle: 'medium', borderColor: 'black'})
              .value(item[key])
            
            i++
            j++

            if (i === 24 || i === 48 || i === 72) {
              j = 0
            }
          }
        }

        self.save(workbook, '08')
      })
    },
    renderReport9 () {
      let self = this
      self.initAssignmentAreaMonthlyAverage()

      let font = self.font
      XlsxPopulate.fromBlankAsync().then(workbook => {
        let sheetName = 'Assignment Area Monthly Average'
        workbook.addSheet(sheetName)
        workbook.sheet(sheetName)
          .cell('A1')
          .style({fontSize: 21.5, fontFamily: font, bold: true, italic: true, verticalAlignment: 'center', horizontalAlignment: 'center'})
          .value('OPOLI')
        workbook.sheet(sheetName).range('A1:C1').merged(true)

        workbook.sheet(sheetName)
          .cell('I1')
          .style({fontSize: 10, fontFamily: font, bold: true, verticalAlignment: 'center'})
          .value('Date Range:')

        let from = moment(self.from)
        let to = moment(self.to)
        let dateRangeText = from.format('MM/DD/YYYY') + ' 00:00:01 to ' + to.format('MM/DD/YYYY') + ' 23:59:59'
        workbook.sheet(sheetName)
          .cell('J1')
          .style({fontSize: 9, fontFamily: font, verticalAlignment: 'center'})
          .value(dateRangeText)
        workbook.sheet(sheetName).range('J1:M1').merged(true)

        workbook.sheet(sheetName)
          .cell('B2')
          .style({fontSize: 21.5, bold: true, fontFamily: font, verticalAlignment: 'center'})
          .value('09 Assignment Area Monthly Average')
        workbook.sheet(sheetName).range('B2:G2').merged(true)

        workbook.sheet(sheetName)
          .cell('A4')
          .style({fontSize: 9, fontFamily: font, italic: true, verticalAlignment: 'center', horizontalAlignment: 'center'})
          .value('The reporting party acknowledges that no information contained in this report is considered to be a trade secret or any other type of\nproprietary interest of the reporting party.  The reporting party acknowledges that the contents of this report may and can be used by LAWA\nfor any purpose including, but not limited to, traffic analysis, transportation planning, and reports to government entities.')
        workbook.sheet(sheetName).range('A4:M7').merged(true)

        workbook.sheet(sheetName)
          .cell('B9')
          .style({fontSize: 11, fontFamily: font, verticalAlignment: 'center', horizontalAlignment: 'center', border: 'border', borderStyle: 'medium', borderColor: 'black'})
          .value('Time')
        workbook.sheet(sheetName)
          .cell('C9')
          .style({fontSize: 11, fontFamily: font, verticalAlignment: 'center', horizontalAlignment: 'center', border: 'border', borderStyle: 'medium', borderColor: 'black'})
          .value('Vehicle\nCount')

        workbook.sheet(sheetName)
          .cell('E9')
          .style({fontSize: 11, fontFamily: font, verticalAlignment: 'center', horizontalAlignment: 'center', border: 'border', borderStyle: 'medium', borderColor: 'black'})
          .value('Time')
        workbook.sheet(sheetName)
          .cell('F9')
          .style({fontSize: 11, fontFamily: font, verticalAlignment: 'center', horizontalAlignment: 'center', border: 'border', borderStyle: 'medium', borderColor: 'black'})
          .value('Vehicle\nCount')

        workbook.sheet(sheetName)
          .cell('H9')
          .style({fontSize: 11, fontFamily: font, verticalAlignment: 'center', horizontalAlignment: 'center', border: 'border', borderStyle: 'medium', borderColor: 'black'})
          .value('Time')
        workbook.sheet(sheetName)
          .cell('I9')
          .style({fontSize: 11, fontFamily: font, verticalAlignment: 'center', horizontalAlignment: 'center', border: 'border', borderStyle: 'medium', borderColor: 'black'})
          .value('Vehicle\nCount')

        workbook.sheet(sheetName)
          .cell('K9')
          .style({fontSize: 11, fontFamily: font, verticalAlignment: 'center', horizontalAlignment: 'center', border: 'border', borderStyle: 'medium', borderColor: 'black'})
          .value('Time')
        workbook.sheet(sheetName)
          .cell('L9')
          .style({fontSize: 11, fontFamily: font, verticalAlignment: 'center', horizontalAlignment: 'center', border: 'border', borderStyle: 'medium', borderColor: 'black'})
          .value('Vehicle\nCount')

        let row = 10
        let i = 0
        let j = 0
        let rowNumber = row + j
        for (let property in self.report.assignmentAreaMonthlyAverage) {
          if (!self.report.assignmentAreaMonthlyAverage.hasOwnProperty(property)) {
            continue
          }
          let timeColumn = 'B'
          let countColumn = 'C'

          if (i > 23 && i <= 47) {
            timeColumn = 'E'
            countColumn = 'F'
          } else if (i > 47 && i <= 71) {
            timeColumn = 'H'
            countColumn = 'I'
          } else if (i > 71) {
            timeColumn = 'K'
            countColumn = 'L'
          }

          let item = self.report.assignmentAreaMonthlyAverage[property]

          rowNumber = row + j
          let timeCell = timeColumn + rowNumber
          let countCell = countColumn + rowNumber

          workbook.sheet(sheetName)
            .cell(timeCell)
            .style({fontSize: 11, fontFamily: font, verticalAlignment: 'center', horizontalAlignment: 'center', border: 'border', borderStyle: 'medium', borderColor: 'black'})
            .value(property)
          workbook.sheet(sheetName)
            .cell(countCell)
            .style({fontSize: 11, fontFamily: font, verticalAlignment: 'center', horizontalAlignment: 'center', border: 'border', borderStyle: 'medium', borderColor: 'black'})
            .value(item)
          
          i++
          j++

          if (i === 24 || i === 48 || i === 72) {
            j = 0
          }
        }

        self.save(workbook, '09')
      })
    },
    renderAbtReport () {
      let self = this
      self.initAbtReport()

      let font = self.font
      XlsxPopulate.fromBlankAsync().then(workbook => {
        let sheetName = 'Summary'
        workbook.addSheet(sheetName)

        workbook.sheet(sheetName)
          .column('A').width(20)
        workbook.sheet(sheetName)
          .column('B').width(20)
        workbook.sheet(sheetName)
          .column('C').width(20)

        workbook.sheet(sheetName)
          .cell('A1')
          .style({fontSize: 11, fontFamily: font, bold: true, verticalAlignment: 'center', horizontalAlignment: 'center',
              border: 'border', borderStyle: 'medium', borderColor: 'black'})
          .value('Reporting Year')

        workbook.sheet(sheetName)
          .cell('B1')
          .style({fontSize: 11, fontFamily: font, bold: true, verticalAlignment: 'center', horizontalAlignment: 'center',
              border: 'border', borderStyle: 'medium', borderColor: 'black'})
          .value('Reporting Month')

        workbook.sheet(sheetName)
          .cell('C1')
          .style({fontSize: 11, fontFamily: font, bold: true, verticalAlignment: 'center', horizontalAlignment: 'center',
              border: 'border', borderStyle: 'medium', borderColor: 'black'})
          .value('Location Code')

        workbook.sheet(sheetName)
          .cell('D1')
          .style({fontSize: 11, fontFamily: font, bold: true, verticalAlignment: 'center', horizontalAlignment: 'center',
              border: 'border', borderStyle: 'medium', borderColor: 'black'})
          .value('Day')

        workbook.sheet(sheetName)
          .cell('E1')
          .style({fontSize: 11, fontFamily: font, bold: true, verticalAlignment: 'center', horizontalAlignment: 'center',
              border: 'border', borderStyle: 'medium', borderColor: 'black'})
          .value('Pickup')

        workbook.sheet(sheetName)
          .cell('F1')
          .style({fontSize: 11, fontFamily: font, bold: true, verticalAlignment: 'center', horizontalAlignment: 'center',
              border: 'border', borderStyle: 'medium', borderColor: 'black'})
          .value('Dropoff')

        workbook.sheet(sheetName)
          .cell('G1')
          .style({fontSize: 11, fontFamily: font, bold: true, verticalAlignment: 'center', horizontalAlignment: 'center',
              border: 'border', borderStyle: 'medium', borderColor: 'black'})
          .value('Total')

        let rowNumber = 2

        let report = self.report.abtReport

        for (let property in report) {
          if (!report.hasOwnProperty(property)) {
            continue
          }

          let monthItem = report[property]
          workbook.sheet(sheetName)
            .cell('A' + rowNumber)
            .style({fontSize: 11, fontFamily: font, verticalAlignment: 'center', horizontalAlignment: 'center'})
            .value(monthItem.year)

          workbook.sheet(sheetName)
            .cell('B' + rowNumber)
            .style({fontSize: 11, fontFamily: font, verticalAlignment: 'center', horizontalAlignment: 'center'})
            .value(property)

          for (let i = 0; i < monthItem.days.length; i++) {
            let dayItem = monthItem.days[i]

            workbook.sheet(sheetName)
              .cell('C' + rowNumber)
              .style({fontSize: 11, fontFamily: font, verticalAlignment: 'center', horizontalAlignment: 'center'})
              .value('LAX')

            workbook.sheet(sheetName)
              .cell('D' + rowNumber)
              .style({fontSize: 11, fontFamily: font, verticalAlignment: 'center', horizontalAlignment: 'right'})
              .value(i + 1)

            workbook.sheet(sheetName)
              .cell('E' + rowNumber)
              .style({fontSize: 11, fontFamily: font, verticalAlignment: 'center', horizontalAlignment: 'right'})
              .value(dayItem.pickup)

            workbook.sheet(sheetName)
              .cell('F' + rowNumber)
              .style({fontSize: 11, fontFamily: font, verticalAlignment: 'center', horizontalAlignment: 'right'})
              .value(dayItem.dropoff)

            workbook.sheet(sheetName)
              .cell('G' + rowNumber)
              .style({fontSize: 11, fontFamily: font, verticalAlignment: 'center', horizontalAlignment: 'right'})
              .value(dayItem.total)

            rowNumber++
          }

          let monthSheetName = property + ' ' + monthItem.year
          workbook.addSheet(monthSheetName)

          workbook.sheet(monthSheetName)
            .column('A').width(20)
          workbook.sheet(monthSheetName)
            .column('B').width(20)
          workbook.sheet(monthSheetName)
            .column('C').width(25)
          workbook.sheet(monthSheetName)
            .column('E').width(25)
          workbook.sheet(monthSheetName)
            .column('F').width(25)

          workbook.sheet(monthSheetName)
            .cell('A1')
            .style({fontSize: 11, fontFamily: font, bold: true, verticalAlignment: 'center', horizontalAlignment: 'center',
              border: 'border', borderStyle: 'medium', borderColor: 'black'})
            .value('unique_id')

          workbook.sheet(monthSheetName)
            .cell('B1')
            .style({fontSize: 11, fontFamily: font, bold: true, verticalAlignment: 'center', horizontalAlignment: 'center',
              border: 'border', borderStyle: 'medium', borderColor: 'black'})
            .value('plate')

          workbook.sheet(monthSheetName)
            .cell('C1')
            .style({fontSize: 11, fontFamily: font, bold: true, verticalAlignment: 'center', horizontalAlignment: 'center',
              border: 'border', borderStyle: 'medium', borderColor: 'black'})
            .value('event_time')

          workbook.sheet(monthSheetName)
            .cell('D1')
            .style({fontSize: 11, fontFamily: font, bold: true, verticalAlignment: 'center', horizontalAlignment: 'center',
              border: 'border', borderStyle: 'medium', borderColor: 'black'})
            .value('event_type')

          workbook.sheet(monthSheetName)
            .cell('E1')
            .style({fontSize: 11, fontFamily: font, bold: true, verticalAlignment: 'center', horizontalAlignment: 'center',
              border: 'border', borderStyle: 'medium', borderColor: 'black'})
            .value('lat')

          workbook.sheet(monthSheetName)
            .cell('F1')
            .style({fontSize: 11, fontFamily: font, bold: true, verticalAlignment: 'center', horizontalAlignment: 'center',
              border: 'border', borderStyle: 'medium', borderColor: 'black'})
            .value('lng')

          let monthRowNumber = 2

          for (let j = 0; j < monthItem.rsvp.length; j++) {
            let rsvp = monthItem.rsvp[j]

            workbook.sheet(monthSheetName)
              .cell('A' + monthRowNumber)
              .style({fontSize: 11, fontFamily: font, verticalAlignment: 'center', horizontalAlignment: 'center'})
              .value(rsvp.id)
            
            workbook.sheet(monthSheetName)
              .cell('B' + monthRowNumber)
              .style({fontSize: 11, fontFamily: font, verticalAlignment: 'center', horizontalAlignment: 'center'})
              .value(rsvp.driver.license)
            
            workbook.sheet(monthSheetName)
              .cell('C' + monthRowNumber)
              .style({fontSize: 11, fontFamily: font, verticalAlignment: 'center', horizontalAlignment: 'center'})
              .value(rsvp.entry.time)
            
            workbook.sheet(monthSheetName)
              .cell('D' + monthRowNumber)
              .style({fontSize: 11, fontFamily: font, verticalAlignment: 'center', horizontalAlignment: 'center'})
              .value(rsvp.isPickup ? 'Pick-Up' : 'Drop-Off')
            
            workbook.sheet(monthSheetName)
              .cell('E' + monthRowNumber)
              .style({fontSize: 11, fontFamily: font, verticalAlignment: 'center', horizontalAlignment: 'center'})
              .value(rsvp.entry.lat)
            
            workbook.sheet(monthSheetName)
              .cell('F' + monthRowNumber)
              .style({fontSize: 11, fontFamily: font, verticalAlignment: 'center', horizontalAlignment: 'center'})
              .value(rsvp.entry.lng)

            monthRowNumber++
          }
        }

        self.save(workbook, 'ABT')
      })
    },
    saveExcel (workbook, filename) {
      workbook.deleteSheet('Sheet1')
      workbook.outputAsync().then(function (blob) {
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          // If IE, you must uses a different method.
          window.navigator.msSaveOrOpenBlob(blob, filename)
        } else {
          let url = window.URL.createObjectURL(blob)
          let a = document.createElement('a')
          document.body.appendChild(a)
          a.href = url
          a.download = filename
          a.click()
          window.URL.revokeObjectURL(url)
          document.body.removeChild(a)
        }
      })
    },
    save (workbook, reportNumber) {
      let self = this
      let from = moment(self.from)
      let to = moment(self.to)
      let filename = 'Opoli TNC Report ' + reportNumber + ' ' + from.format('MM-DD-YYYY') + ' to ' + to.format('MM-DD-YYYY') + '.xlsx'
      // save the workbook
      workbook.deleteSheet('Sheet1')
      workbook.outputAsync().then(function (blob) {
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          // If IE, you must uses a different method.
          window.navigator.msSaveOrOpenBlob(blob, filename)
        } else {
          let url = window.URL.createObjectURL(blob)
          let a = document.createElement('a')
          document.body.appendChild(a)
          a.href = url
          a.download = filename
          a.click()
          window.URL.revokeObjectURL(url)
          document.body.removeChild(a)
        }
      })
    }
  },
  watch: {
    show (value) {
      if (!value) {
        return
      }
      this.from = null
      this.to = null
      this.error.show = false
      this.selectedReports = [
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.tnc-report {
  background-color: #fff;
  border-radius: 3px;
  max-width: 400px;
  margin: 0 auto;
  box-shadow: 0 2px 8px rgba(0,0,0,0.35);
  padding: 20px;

  & .title {
    text-align: center;
    font-weight: 700;
    margin-bottom: 20px;
  }

  & .date-input {
    margin-bottom: 10px;

    & label {
       margin-bottom: 5px;
       font-size: 14px;
       color: #777;
       display: block;
     }
  }

  & .instruction {
    text-align: center;
    margin-bottom: 10px;
    font-size: 14px;
    font-weight: 700;
    color: #777;
    text-decoration: underline;
  }
}

.report-select {
  background-color: #f5f5f5;
  border: 1px solid rgba(0,0,0,0.2);
  border-bottom: 0;
  margin-bottom: 20px;
  & .check-input {
    display: block;
    border-bottom: 1px solid rgba(0,0,0,0.2);
    padding: 5px 10px;
    & > * {
      display: inline-block;
      vertical-align: middle;
      width: auto;
      margin: 0;
    }

    & > span {
      margin-left: 5px;
    }
  }
}

.error {
  background-color: #F25E0D;
  font-size: 14px;
  text-align: center;
  color: #fff;
  border-radius: 3px;
  padding: 5px;
  margin-bottom: 15px;
}
.padding-R { padding-right: 7px; }
.padding-L { padding-left: 7px; }
</style>



// WEBPACK FOOTER //
// src/components/Reports/LAWAReport.vue